<template>
  <div id="edit" @mousemove="mouseMove" @mouseup="mouseUp" @mousedown="mouseDown">
    <div class="pc-body" @contextmenu.prevent="'return'">

      <!---------------- 顶栏 ---------------->
      <div class="pc-head">
        <div class="pc-head-back" title="返回">
          <mu-icon size="28" value="reply"></mu-icon>
        </div>
        <div class="pc-info">{{dynalt.name}}</div>
        <div class="pc-head-right">
          <div class="pc-head-ico" target="_blank" @click="funcHandle('view')" id="previewYunZutai">
            <mu-icon size="14" value="visibility" style="float: left; margin-top: 22px; margin-right: 4px"></mu-icon>预览
          </div>
          <div class="pc-head-ico" id="saveYunZutai" @click="funcHandle('save')">
            <mu-icon size="14" value="save" style="float: left; margin-top: 22px; margin-right: 4px"></mu-icon>保存
          </div>
          <div class="pc-head-ico" id="fabuYunZutai" @click="funcHandle('release')" v-show="!dynalt.release">
            <mu-icon size="14" value="near_me" style="float: left; margin-top: 22px; margin-right: 4px"></mu-icon>发布
          </div>
        </div>
      </div>

      <!---------------- 功能栏 ---------------->
      <div class="pc-left" id="pc-left">
        <div class="pc-leftUL">
          <div class="pc-leftUL-item" v-for="(item, index) in funcUL" :key="index" :style="
                funcULCur == index
                  ? 'color: #fff;background-color: #4c84ff;'
                  : ''
              " @click="funcULClick(index)">
            <div>
              <mu-icon size="22" :value="item.icon"></mu-icon>
            </div>
            <p>{{ item.title }}</p>
          </div>
        </div>
        <div class="pc-leftRM">
          <div class="pc-leftUL-item" style="padding: 10px 0; height: 60px; color: #fff">
            <div>
              <mu-icon size="26" value="keyboard"></mu-icon>
            </div>
            <p>快捷键</p>
          </div>
          <div class="pc-leftUL-item" style="padding: 10px 0; height: 60px; color: #fff">
            <div>
              <mu-icon size="26" value="library_books"></mu-icon>
            </div>
            <p>文档</p>
          </div>
          <div class="pc-leftUL-item" style="padding: 10px 0; height: 60px; color: #fff">
            <div>
              <mu-icon size="26" value="help"></mu-icon>
            </div>
            <p></p>
          </div>
        </div>
      </div>

      <!---------------- 左侧工具栏 ---------------->
      <div class="leftNav" :style="leftNavStyle">
        <transition name="fade">
          <div class="funcItem" v-show="funcULCur == 0">
            <div class="leftNav-base" v-for="(item, index) in LNoption.base" :key="index" @mousedown="
                  leftNavClick($event, index, 'base', { index, item })
                ">
              <div>
                <mu-icon size="40" color="grey700" :value="index"></mu-icon>
              </div>
              <span>{{ item }}</span>
            </div>
          </div>
        </transition>
        <transition name="fade">
          <div class="funcItem" v-show="funcULCur == 1">
            <div v-for="(item, index) in LNoption.module" :key="index">
              <div class="funcItem-title">
                <div></div>
                <span>{{ item.name }}</span>
                <div></div>
              </div>
              <div style="width: calc(100% + 10px)">
                <div class="leftNav-module" v-for="(im, idx) in item.list" :key="idx" @mousedown="leftNavClick($event, im.id, 'module', im)">
                  <img :src="im.img" draggable="false" />
                  <div>{{ im.title }}</div>
                </div>
              </div>
            </div>
          </div>
        </transition>
        <transition name="fade">
          <div class="funcItem" v-show="funcULCur == 2">
            <div style="width: calc(100% + 10px)" v-for="(item, index) in LNoption.material" :key="index">
              <div class="leftNav-material" @mousedown="leftNavClick($event, item, 'material', item)">
                <img :src="item" draggable="false" />
              </div>
            </div>
            <div style="
                  float: left;
                  width: 100%;
                  height: 20px;
                  text-align: center;
                ">
              已无更多数据
            </div>
          </div>
        </transition>

        <!-- 交互 -->
        <transition name="fade">
          <div class="funcItem" v-show="funcULCur == 3">
            <div v-for="(item, index) in LNoption.active" :key="index">
              <div class="funcItem-title">
                <div></div>
                <span>{{ item.name }}</span>
                <div></div>
              </div>
              <div style="width: calc(100% + 10px)">
                <div class="leftNav-active" v-for="(im, idx) in item.list" :key="idx" @mousedown="leftNavClick($event, im.id, 'active', im)">
                  <img :src="im.img" draggable="false" />
                  <div>{{ im.title }}</div>
                </div>
              </div>
            </div>
          </div>
        </transition>
        <!-- 上传 -->
        <transition name="fade">
          <div class="funcItem" v-show="funcULCur == 4">
            <div style="height: calc(100% - 40px)">
              <div style="width: calc(100% + 10px)" v-for="(item, index) in LNoption.image" :key="index">
                <div class="leftNav-image" @mousedown="leftNavClick($event, item, 'image', item)">
                  <div>
                    <img :src="item" draggable="false" v-if="viewLock" />
                  </div>
                  <span>{{
                      item.split("/")[item.split("/").length - 1]
                    }}</span>
                  <button @mousedown="leftNavImageDelete(item)">
                    <mu-icon size="16" color="#fff" value="delete"></mu-icon>
                  </button>
                </div>
              </div>
            </div>
            <div class="funcItem-buttom" style="text-align: center">
              <label for="leftNavImage">本地上传</label>
              <input id="leftNavImage" v-show="false" type="file" @change="leftNavEdit($event, 'image')" accept=".gif, .png, .jpeg, .jpg, .svg" />
            </div>
          </div>
        </transition>
      </div>

      <!---------------- 编辑区 ---------------->
      <div class="pc-con" v-if="Object.keys(dynalt).length !== 0">
        <div class="editNav-side" :style="editNavStyle()" v-if="editNavShow('outside')">
          <div class="editNav-item" :style="editNavItemStyle(index)" v-for="(item, index) in dynalt.config.canvas" :key="index"
            @click="editNav_Event('show', index)" @contextmenu.prevent="editNav_Event('delete', index)">
            {{ item.name }}
          </div>
        </div>
        <mu-fade-transition>
          <div class="pc-edit" ref="pcEdit">
            <mu-scale-transition>
              <div class="editCenter" v-if="centerShow" :style="editCenterStyle()" @mousedown="editCenterClick">
                <div :class="{'editCenter-guide':true, 'guide-enable': RNoption.auxLine} " @mousedown="elementClick($event,-1)">
                </div>
                <div class="editCenter-expansion"></div>
                <div class="editNav-side" :style="editNavStyle()" v-if="editNavShow('inside')">
                  <div class="editNav-item" :style="editNavItemStyle(index)" v-for="(item, index) in dynalt.config.canvas" :key="index"
                    @click="editNav_Event('show', index)" @contextmenu.prevent="editNav_Event('delete', index)">
                    {{ item.name }}
                  </div>
                </div>
                <div class="editCenter-item" v-for="(item,index) in pCanvas.element" :key="index" :style="elementBoxStyle(item.box,index)">
                  <div class="editCenter-item-body" @mousedown="elementClick($event,index)">
                    <div class="editCenter-base-mask"></div>
                    <!-- 基本-文本 -->
                    <div v-if="item.type=='text_fields'" class="editCenter-base" :style="elementStyle(item)">{{item.value }}</div>
                    <!-- 基本-时间 -->
                    <div v-if="item.type=='date_range'" class="editCenter-base" :style="elementStyle(item)">{{item.value.local }}</div>
                    <!-- 基本-超链接 -->
                    <a v-if="item.type=='link'" class="editCenter-base" :style="elementStyle(item)+'cursor: pointer;'"
                      @click="link_Event(item.value.to)">{{item.value.name}}</a>
                    <!-- 基本-刷新 -->
                    <a v-if="item.type=='replay'" class="editCenter-base" :style="elementStyle(item)+'cursor: pointer;'"
                      @click="replay_Event()">{{ item.value }}</a>
                    <!-- 基本-切换画布 -->
                    <a v-if="item.type=='switch_video'" class="editCenter-base" :style="elementStyle(item)+'cursor: pointer;'"
                      @click="switchvideo_Event(item.value.to)">{{item.value.name}}</a>
                    <!-- 基本-iframe -->
                    <iframe v-if="item.type=='web'" class="editCenter-base" :src="item.value" />
                    <!-- 基本-全屏 -->
                    <img v-if="item.type=='fullscreen'" class="editCenter-base" :src="require('../assets/edit/fullscreen.svg')" @click="fullscreen_Event" />
                    <!-- 图库 and 上传 -->
                    <img v-if="item.type=='material' || item.type=='image'" class="editCenter-base" :src="item.value" />
                    <!-- 交互  -->
                    <canvas v-if="item.type=='active'" :id="item.style.id" :height="item.box.height" :width="item.box.width"></canvas>
                    <!-- 组件-数据 -->
                    <div v-if="item.type=='data-value'" class="editCenter-base" :style="elementStyle(item)">
                      {{ dataShow(realtime[item.value.label.labelID], item.value.content, realtime.update) }}
                    </div>
                    <!-- 组件-开关 -->
                    <div v-if="item.type=='data-switch'" class="editCenter-base">
                      <img v-show="0==switchShow(realtime[item.value.label.labelID], realtime.update)" :src="item.value.closeImg" class="editCenter-base"
                        @click="switch_Event(item, 1)" />
                      <img v-show="1==switchShow(realtime[item.value.label.labelID], realtime.update)" :src="item.value.openImg" class="editCenter-base"
                        @click="switch_Event(item, 0)" />
                      <img v-show="-1==switchShow(realtime[item.value.label.labelID], realtime.update)" :src="item.value.errorImg" class="editCenter-base" />
                    </div>
                    <!-- 组件-控制 -->
                    <img v-if="item.type=='data-control'" class="editCenter-base" :src="item.value.img" @click="control_Event(item)" />
                  </div>
                  <div class="editCenter-item-lock" v-if="item.box.lock">
                    <mu-icon size="12" value="lock" color="#666"></mu-icon>
                  </div>
                  <div v-show="elementCur==index && !item.box.lock">
                    <div class="editCenter-resizable resizable-n" @mousedown="resizableClick($event,' n', 'n-resize' )">
                    </div>
                    <div class="editCenter-resizable resizable-e" @mousedown="resizableClick($event,'e', 'e-resize')"></div>
                    <div class="editCenter-resizable resizable-s" @mousedown="resizableClick($event,'s', 's-resize')"></div>
                    <div class="editCenter-resizable resizable-w" @mousedown="resizableClick($event,'w', 'w-resize')"></div>
                    <div class="editCenter-resizable resizable-ne" @mousedown="resizableClick($event,'ne', 'ne-resize')"></div>
                    <div class="editCenter-resizable resizable-se" @mousedown="resizableClick($event,'se', 'se-resize')"></div>
                    <div class="editCenter-resizable resizable-sw" @mousedown="resizableClick($event,'sw', 'sw-resize')"></div>
                    <div class="editCenter-resizable resizable-nw" @mousedown="resizableClick($event,'nw', 'nw-resize')"></div>
                    <div class="editCenter-resizable-rotate " @mousedown="resizableClick($event,'rotate','pointer')"></div>
                  </div>
                </div>
              </div>
            </mu-scale-transition>
          </div>
        </mu-fade-transition>
      </div>

      <!---------------- 右侧工具栏 ---------------->
      <div class="pc-right" :style="rightNavStyle">
        <div class="rightNav-btn" @click="rightNavHiddenEvent()" :style="
              rightNavHidden
                ? 'transform: translateX(-36px);transition: transform 0.5s;'
                : ''
            ">
          <mu-icon size="24" value="view_carousel" color="grey50" v-show="rightNavHidden"></mu-icon>
          <mu-icon size="24" value="view_array" color="grey50" v-show="!rightNavHidden"></mu-icon>
        </div>
        <div class="rightNav">
          <div class="rightNav-head">
            <div :class="{ rightNavHeadA: true, rightNavHeadB: rightNavCur }" @click="rightNavSwitch(true)">
              基本设置
            </div>
            <div :class="{ rightNavHeadA: true, rightNavHeadB: !rightNavCur }" @click="rightNavSwitch(false)">
              高级设置
            </div>
          </div>
          <div class="rightNav-body" v-if="Object.keys(dynalt).length !== 0">
            <!-- - - - - -  基本设置 - - - - - -->
            <transition name="slide-left">
              <div class="rightNav-view" v-if="rightNavCur">
                <!----- 功能选择 ----->
                <div class="rightNav-item">
                  <div class="rightNav-text">功能选择</div>
                  <div class="rightNav-item-list">
                    <div :class="{
                          'rightNav-checkbox': RNoption.editEnable,
                          'rightNav-box': true,
                        }" style="background:none;float:left" @click="RNoptionEdit($event, 'editEnable', true)">
                      <mu-icon size="20" value="picture_in_picture_alt" color="#fff"></mu-icon>
                    </div>
                    <div :class="{
                          'rightNav-checkbox': !RNoption.editEnable,
                          'rightNav-box': true,
                        }" style="background:none;float:left" @click="RNoptionEdit($event, 'editEnable', false)">
                      <mu-icon size="20" value="settings_overscan" color="#fff"></mu-icon>
                    </div>
                  </div>
                </div>
                <!----- 基础设置 ----->
                <div class="rightNav-details">
                  <div></div><span>基础设置</span>
                  <div></div>
                </div>
                <!-- 画布 -->
                <div v-if="elementCur<0">
                  <div class="rightNav-item">
                    <div class="rightNav-text">辅助线</div>
                    <div class="rightNav-box" style="
                        border: 1px solid #000;
                        width: 28px;
                        background: #fff;
                      " @click="
                        RNoptionEdit($event, 'auxLine', !RNoption.auxLine)
                      ">
                      <mu-icon size="20" value="done" color="blue" style="margin: 3px" v-show="RNoption.auxLine">
                      </mu-icon>
                    </div>
                    <div class="rightNav-separate" />
                    <div class="rightNav-text">画布宽</div>
                    <div class="rightNav-input" style="width: 50%">
                      <input type="text" v-model="dynalt.config.board.width" />
                    </div>
                    <div class="rightNav-text">画布高</div>
                    <div class="rightNav-input" style="width: 50%">
                      <input type="text" v-model="dynalt.config.board.height" />
                    </div>
                    <div class="rightNav-separate" />
                    <div class="rightNav-text">运行页面自适应</div>
                    <div class="rightNav-select" style="width: 50%">
                      <select name id v-model="dynalt.config.board.adaptive">
                        <option :value="true">是</option>
                        <option :value="false">否</option>
                      </select>
                    </div>
                  </div>
                  <div class="rightNav-details">
                    <div></div><span>详细设置</span>
                    <div></div>
                  </div>
                  <div class="rightNav-item">
                    <div class="rightNav-text">背景色</div>
                    <div class="rightNav-colorbox">
                      <div class="rightNav-box" :style="'border: 1px solid #000;background:' +dynalt.config.canvas[canvasCur].background"
                        @click="RNoptionEdit($event, 'canvas-background', canvasCur)"></div>
                    </div>
                  </div>
                </div>
                <!-- 组件 -->
                <div v-if="elementCur>=0">
                  <div v-if="pElement.box.lock">
                    <div class="rightNav-item">
                      <div class="rightNav-button">
                        <mu-button small color="primary" style="padding:0 12px" @click="RNoptionEdit($event, 'box-lock', false)">取消锁定</mu-button>
                      </div>
                    </div>
                  </div>
                  <div v-if="!pElement.box.lock">
                    <!-- 基本-文本 -->
                    <div v-if="pElement.type=='text_fields'">
                      <div class="rightNav-item">
                        <div class="rightNav-text">修改文本</div>
                        <div class="rightNav-textarea">
                          <textarea v-model="pElement.value"></textarea>
                        </div>
                      </div>
                      <div class="rightNav-item">
                        <div class="rightNav-text">文本设置</div>
                        <div class="rightNav-manybox">
                          <select style="width:25%" v-for="(item,index) in textFields" :key="index" v-model="pElement.style[index]">
                            <option :value="im.val" v-for="(im,idx) in item" :key="idx">{{im.key}}</option>
                          </select>
                        </div>
                        <div class="rightNav-text">文本样式</div>
                        <div class="rightNav-manybox" style="font-family:'wryh'">
                          <button style="color:#E53232" @click="RNoptionEdit($event, 'style-color')">A</button>
                          <button style="fontWeight: bold"
                            @click="RNoptionEdit($event, 'style-fontWeight', pElement.style.fontWeight=='normal'?'bold': 'normal')">B</button>
                          <button style="fontStyle:italic"
                            @click="RNoptionEdit($event, 'style-fontStyle', pElement.style.fontStyle=='normal'?'italic': 'normal')">I</button>
                          <button style="textDecoration: underline"
                            @click="RNoptionEdit($event, 'style-textDecoration', pElement.style.textDecoration=='none'?'underline': 'none')">U</button>
                        </div>
                        <div class="rightNav-separate" />
                        <div class="rightNav-button">
                          <mu-button small color="primary" style="padding:0 12px" @click="RNoptionEdit($event, 'box-lock', true)">锁定</mu-button>
                        </div>
                        <div class="rightNav-separate" />
                        <div class="rightNav-text">背景色</div>
                        <div class="rightNav-colorbox">
                          <div class="rightNav-box" :style="'border: 1px solid #000;background:'+pElement.box.background"
                            @click="RNoptionEdit($event, 'box-background')"></div>
                        </div>
                      </div>
                    </div>
                    <!-- 基本-时间 -->
                    <div v-if="pElement.type=='date_range'">
                      <div class="rightNav-item">
                        <div class="rightNav-text">文本设置</div>
                        <div class="rightNav-manybox">
                          <select style="width:25%" v-for="(item,index) in textFields" :key="index" v-model="pElement.style[index]">
                            <option :value="im.val" v-for="(im,idx) in item" :key="idx">{{im.key}}</option>
                          </select>
                        </div>
                        <div class="rightNav-text">文本样式</div>
                        <div class="rightNav-manybox" style="font-family:'wryh'">
                          <button style="color:#E53232" @click="RNoptionEdit($event, 'style-color')">A</button>
                          <button style="fontWeight: bold"
                            @click="RNoptionEdit($event, 'style-fontWeight', pElement.style.fontWeight=='normal'?'bold': 'normal')">B</button>
                          <button style="fontStyle:italic"
                            @click="RNoptionEdit($event, 'style-fontStyle', pElement.style.fontStyle=='normal'?'italic': 'normal')">I</button>
                          <button style="textDecoration: underline"
                            @click="RNoptionEdit($event, 'style-textDecoration', pElement.style.textDecoration=='none'?'underline': 'none')">U</button>
                        </div>
                        <div class="rightNav-separate" />
                        <div class="rightNav-button">
                          <mu-button small color="primary" style="padding:0 12px" @click="RNoptionEdit($event, 'box-lock', true)">锁定</mu-button>
                        </div>
                        <div class="rightNav-separate" />
                        <div class="rightNav-text">背景色</div>
                        <div class="rightNav-colorbox">
                          <div class="rightNav-box" :style="'border: 1px solid #000;background:'+pElement.box.background"
                            @click="RNoptionEdit($event, 'box-background')"></div>
                        </div>
                      </div>
                    </div>
                    <!-- 基本-超链接 -->
                    <div v-if="pElement.type=='link'">
                      <div class="rightNav-item">
                        <div class="rightNav-text">修改文本</div>
                        <div class="rightNav-textarea">
                          <textarea v-model="pElement.value.name"></textarea>
                        </div>
                      </div>
                      <div class="rightNav-item">
                        <div class="rightNav-text">自定义链接</div>
                        <div class="rightNav-input" style="width: 100%">
                          <input type="text" v-model="pElement.value.to" />
                        </div>
                        <div class="rightNav-button" style="margin-top: 10px">
                          <a :href="pElement.value.to" style="color:#fff" target="_blank">
                            <mu-button small color="primary" style="padding:0 12px;">测试链接</mu-button>
                          </a>
                        </div>
                        <div class="rightNav-separate" />
                        <div class="rightNav-text">文本设置</div>
                        <div class="rightNav-manybox">
                          <select style="width:25%" v-for="(item,index) in textFields" :key="index" v-model="pElement.style[index]">
                            <option :value="im.val" v-for="(im,idx) in item" :key="idx">{{im.key}}</option>
                          </select>
                        </div>
                        <div class="rightNav-text">文本样式</div>
                        <div class="rightNav-manybox" style="font-family:'wryh'">
                          <button style="color:#E53232" @click="RNoptionEdit($event, 'style-color')">A</button>
                          <button style="fontWeight: bold"
                            @click="RNoptionEdit($event, 'style-fontWeight', pElement.style.fontWeight=='normal'?'bold': 'normal')">B</button>
                          <button style="fontStyle:italic"
                            @click="RNoptionEdit($event, 'style-fontStyle', pElement.style.fontStyle=='normal'?'italic': 'normal')">I</button>
                          <button style="textDecoration: underline"
                            @click="RNoptionEdit($event, 'style-textDecoration', pElement.style.textDecoration=='none'?'underline': 'none')">U</button>
                        </div>
                        <div class="rightNav-separate" />
                        <div class="rightNav-button">
                          <mu-button small color="primary" style="padding:0 12px" @click="RNoptionEdit($event, 'box-lock', true)">锁定</mu-button>
                        </div>
                        <div class="rightNav-separate" />
                        <div class="rightNav-text">背景色</div>
                        <div class="rightNav-colorbox">
                          <div class="rightNav-box" :style="'border: 1px solid #000;background:'+pElement.box.background"
                            @click="RNoptionEdit($event, 'box-background')"></div>
                        </div>
                      </div>
                    </div>
                    <!-- 基本-刷新 -->
                    <div v-if="pElement.type=='replay'">
                      <div class="rightNav-item">
                        <div class="rightNav-text">修改文本</div>
                        <div class="rightNav-textarea">
                          <textarea v-model="pElement.value"></textarea>
                        </div>
                      </div>
                      <div class="rightNav-item">
                        <div class="rightNav-text">文本设置</div>
                        <div class="rightNav-manybox">
                          <select style="width:25%" v-for="(item,index) in textFields" :key="index" v-model="pElement.style[index]">
                            <option :value="im.val" v-for="(im,idx) in item" :key="idx">{{im.key}}</option>
                          </select>
                        </div>
                        <div class="rightNav-text">文本样式</div>
                        <div class="rightNav-manybox" style="font-family:'wryh'">
                          <button style="color:#E53232" @click="RNoptionEdit($event, 'style-color')">A</button>
                          <button style="fontWeight: bold"
                            @click="RNoptionEdit($event, 'style-fontWeight', pElement.style.fontWeight=='normal'?'bold': 'normal')">B</button>
                          <button style="fontStyle:italic"
                            @click="RNoptionEdit($event, 'style-fontStyle', pElement.style.fontStyle=='normal'?'italic': 'normal')">I</button>
                          <button style="textDecoration: underline"
                            @click="RNoptionEdit($event, 'style-textDecoration', pElement.style.textDecoration=='none'?'underline': 'none')">U</button>
                        </div>
                        <div class="rightNav-separate" />
                        <div class="rightNav-button">
                          <mu-button small color="primary" style="padding:0 12px" @click="RNoptionEdit($event, 'box-lock', true)">锁定</mu-button>
                        </div>
                        <div class="rightNav-separate" />
                        <div class="rightNav-text">背景色</div>
                        <div class="rightNav-colorbox">
                          <div class="rightNav-box" :style="'border: 1px solid #000;background:'+pElement.box.background"
                            @click="RNoptionEdit($event, 'box-background')"></div>
                        </div>
                      </div>
                    </div>
                    <!-- 基本-切换画布 -->
                    <div v-if="pElement.type=='switch_video'">
                      <div class="rightNav-item">
                        <div class="rightNav-text">修改文本</div>
                        <div class="rightNav-textarea">
                          <textarea v-model="pElement.value.name"></textarea>
                        </div>
                        <div class="rightNav-text">选择画布</div>
                        <div class="rightNav-select" style="width: 100%">
                          <select v-model="pElement.value.to">
                            <option :value="-1">请选择画布</option>
                            <option v-show="dynalt.config.canvas.length>1" v-for="(item,index) in dynalt.config.canvas" :key="index" :value="index">
                              {{item.name}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="rightNav-item">
                        <div class="rightNav-text">文本设置</div>
                        <div class="rightNav-manybox">
                          <select style="width:25%" v-for="(item,index) in textFields" :key="index" v-model="pElement.style[index]">
                            <option :value="im.val" v-for="(im,idx) in item" :key="idx">{{im.key}}</option>
                          </select>
                        </div>
                        <div class="rightNav-text">文本样式</div>
                        <div class="rightNav-manybox" style="font-family:'wryh'">
                          <button style="color:#E53232" @click="RNoptionEdit($event, 'style-color')">A</button>
                          <button style="fontWeight: bold"
                            @click="RNoptionEdit($event, 'style-fontWeight', pElement.style.fontWeight=='normal'?'bold': 'normal')">B</button>
                          <button style="fontStyle:italic"
                            @click="RNoptionEdit($event, 'style-fontStyle', pElement.style.fontStyle=='normal'?'italic': 'normal')">I</button>
                          <button style="textDecoration: underline"
                            @click="RNoptionEdit($event, 'style-textDecoration', pElement.style.textDecoration=='none'?'underline': 'none')">U</button>
                        </div>
                        <div class="rightNav-separate" />
                        <div class="rightNav-button">
                          <mu-button small color="primary" style="padding:0 12px" @click="RNoptionEdit($event, 'box-lock', true)">锁定</mu-button>
                        </div>
                        <div class="rightNav-separate" />
                        <div class="rightNav-text">背景色</div>
                        <div class="rightNav-colorbox">
                          <div class="rightNav-box" :style="'border: 1px solid #000;background:'+pElement.box.background"
                            @click="RNoptionEdit($event, 'box-background')"></div>
                        </div>
                      </div>
                    </div>
                    <!-- 基本-iframe -->
                    <div v-if="pElement.type=='web'">
                      <div class="rightNav-item">
                        <div class="rightNav-text">自定义链接</div>
                        <div class="rightNav-input" style="width: 100%">
                          <input type="text" v-model="pElement.value" />
                        </div>
                        <div class="rightNav-separate" />
                        <div class="rightNav-button">
                          <mu-button small color="primary" style="padding:0 12px" @click="RNoptionEdit($event, 'box-lock', true)">锁定</mu-button>
                        </div>
                      </div>
                    </div>
                    <!-- 基本-全屏切换 -->
                    <div v-if="pElement.type=='fullscreen'">
                      <div class="rightNav-item">
                        <div class="rightNav-text">背景色</div>
                        <div class="rightNav-colorbox">
                          <div class="rightNav-box" :style="'border: 1px solid #000;background:'+pElement.box.background"
                            @click="RNoptionEdit($event, 'box-background')"></div>
                        </div>
                        <div class="rightNav-separate" />
                        <div class="rightNav-button">
                          <mu-button small color="primary" style="padding:0 12px" @click="RNoptionEdit($event, 'box-lock', true)">锁定</mu-button>
                        </div>
                      </div>
                    </div>
                    <!-- 图库 -->
                    <div v-if="pElement.type=='material'">
                      <div class="rightNav-item">
                        <div class="rightNav-text">背景色</div>
                        <div class="rightNav-colorbox">
                          <div class="rightNav-box" :style="'border: 1px solid #000;background:'+pElement.box.background"
                            @click="RNoptionEdit($event, 'box-background')"></div>
                        </div>
                        <div class="rightNav-separate" />
                        <div class="rightNav-button">
                          <mu-button small color="primary" style="padding:0 12px" @click="RNoptionEdit($event, 'box-lock', true)">锁定</mu-button>
                        </div>
                      </div>
                    </div>
                    <!-- 上传 -->
                    <div v-if="pElement.type=='image'">
                      <div class="rightNav-item">
                        <div class="rightNav-text">背景色</div>
                        <div class="rightNav-colorbox">
                          <div class="rightNav-box" :style="'border: 1px solid #000;background:'+pElement.box.background"
                            @click="RNoptionEdit($event, 'box-background')"></div>
                        </div>
                        <div class="rightNav-separate" />
                        <div class="rightNav-button">
                          <mu-button small color="primary" style="padding:0 12px" @click="RNoptionEdit($event, 'box-lock', true)">锁定</mu-button>
                        </div>
                      </div>
                    </div>
                    <!-- 交互 -->
                    <div v-if="pElement.type=='active'">
                      <div name="管道" v-if="pElement.style.type == 'active-pipe'">
                        <div class="rightNav-item">
                          <div class="rightNav-text">液体颜色</div>
                          <div class="rightNav-colorbox">
                            <div class="rightNav-box" :style="'border: 1px solid #000;background:'+pElement.style.color"
                              @click="RNoptionEdit($event, 'style-color')"></div>
                          </div>
                          <div class="rightNav-separate" />
                          <div class="rightNav-button">
                            <mu-button small color="primary" style="padding:0 12px" @click="RNoptionEdit($event, 'box-lock', true)">锁定</mu-button>
                          </div>
                        </div>
                      </div>
                      <div name="水池" v-if="pElement.style.type == 'active-pool'">
                        <div class="rightNav-item">
                          <div class="rightNav-text">液体颜色</div>
                          <!-- 右侧工具栏水池当前颜色 -->
                          <div class="rightNav-colorbox">
                            <div class="rightNav-box" :style="'border: 1px solid #000;background:'+pElement.style.waveColor"
                              @click="RNoptionEdit($event, 'style-waveColor')"></div>
                          </div>
                          <div class="rightNav-text">字体颜色</div>
                          <div class="rightNav-colorbox">
                            <div class="rightNav-box" :style="'border: 1px solid #000;background:'+pElement.style.color"
                              @click="RNoptionEdit($event, 'style-color')"></div>
                          </div>
                          <div class="rightNav-text">字体大小</div>
                          <div class="rightNav-input" style="width: 50%">
                            <input type="text" v-model="pElement.style.fontSize" />
                          </div>
                          <div class="rightNav-separate" />
                          <div class="rightNav-button">
                            <mu-button small color="primary" style="padding:0 12px" @click="RNoptionEdit($event, 'box-lock', true)">锁定</mu-button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 组件-数据 -->
                    <div v-if="pElement.type=='data-value'">
                      <div class="rightNav-item">
                        <div class="rightNav-text">文本设置</div>
                        <div class="rightNav-manybox">
                          <select style="width:25%" v-for="(item,index) in textFields" :key="index" v-model="pElement.style[index]">
                            <option :value="im.val" v-for="(im,idx) in item" :key="idx">{{im.key}}</option>
                          </select>
                        </div>
                        <div class="rightNav-text">文本样式</div>
                        <div class="rightNav-manybox" style="font-family:'wryh'">
                          <button style="color:#E53232" @click="RNoptionEdit($event, 'style-color')">A</button>
                          <button style="fontWeight: bold"
                            @click="RNoptionEdit($event, 'style-fontWeight', pElement.style.fontWeight=='normal'?'bold': 'normal')">B</button>
                          <button style="fontStyle:italic"
                            @click="RNoptionEdit($event, 'style-fontStyle', pElement.style.fontStyle=='normal'?'italic': 'normal')">I</button>
                          <button style="textDecoration: underline"
                            @click="RNoptionEdit($event, 'style-textDecoration', pElement.style.textDecoration=='none'?'underline': 'none')">U</button>
                        </div>
                        <div class="rightNav-separate" />
                        <div class="rightNav-button">
                          <mu-button small color="primary" style="padding:0 12px" @click="RNoptionEdit($event, 'box-lock', true)">锁定</mu-button>
                        </div>
                        <div class="rightNav-separate" />
                        <div class="rightNav-text">背景色</div>
                        <div class="rightNav-colorbox">
                          <div class="rightNav-box" :style="'border: 1px solid #000;background:'+pElement.box.background"
                            @click="RNoptionEdit($event, 'box-background')"></div>
                        </div>
                      </div>
                    </div>
                    <!-- 组件-开关 -->
                    <div v-if="pElement.type=='data-switch'">
                      <div class="rightNav-item">
                        <div class="rightNav-button">
                          <mu-button small color="primary" style="padding:0 12px" @click="RNoptionEdit($event, 'box-lock', true)">锁定</mu-button>
                        </div>
                        <div class="rightNav-separate" />
                        <div class="rightNav-text">背景色</div>
                        <div class="rightNav-colorbox">
                          <div class="rightNav-box" :style="'border: 1px solid #000;background:'+pElement.box.background"
                            @click="RNoptionEdit($event, 'box-background')"></div>
                        </div>
                      </div>
                    </div>
                    <!-- 组件-控制 -->
                    <div v-if="pElement.type=='data-control'">
                      <div class="rightNav-item">
                        <div class="rightNav-button">
                          <mu-button small color="primary" style="padding:0 12px" @click="RNoptionEdit($event, 'box-lock', true)">锁定</mu-button>
                        </div>
                        <div class="rightNav-separate" />
                        <div class="rightNav-text">背景色</div>
                        <div class="rightNav-colorbox">
                          <div class="rightNav-box" :style="'border: 1px solid #000;background:'+pElement.box.background"
                            @click="RNoptionEdit($event, 'box-background')"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!----- 显示设置 ----->
                <div v-if="elementCur>=0 && !pElement.box.lock">
                  <div class="rightNav-details">
                    <div></div><span>显示设置</span>
                    <div></div>
                  </div>
                  <div class="rightNav-item">
                    <div class="rightNav-text">大小</div>
                    <div class="rightNav-item-list">
                      <span>宽</span>
                      <div class="rightNav-input" style="width: 60px">
                        <input type="text" v-model="pElement.box.width" />
                      </div>
                      <span>高</span>
                      <div class="rightNav-input" style="width: 60px">
                        <input type="text" v-model="pElement.box.height" />
                      </div>
                    </div>
                    <div class="rightNav-separate" />
                    <div class="rightNav-text">位置</div>
                    <div class="rightNav-item-list">
                      <span>X</span>
                      <div class="rightNav-input" style="width: 60px">
                        <input type="text" v-model="pElement.box.left" />
                      </div>
                      <span>Y</span>
                      <div class="rightNav-input" style="width: 60px">
                        <input type="text" v-model="pElement.box.top" />
                      </div>
                    </div>
                    <div class="rightNav-separate" />
                    <div class="rightNav-text">旋转</div>
                    <div style="height:30px;width:100%;display:flex">
                      <mu-slider style="flex:1;margin:0 16px 0 0;height:30px" v-model="pElement.box.rotate" :max="359" :step="1"></mu-slider>
                      <div class="rightNav-input" style="width: 60px;">
                        <input type="text" v-model="pElement.box.rotate" disabled />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
            <!-- - - - - -  高级设置 - - - - - -->
            <transition name=" slide-right">
              <div class="rightNav-view" v-if="!rightNavCur">
                <div v-if="elementCur<0">
                  <div class="rightNav-item">
                    <div class="rightNav-text">添加画布</div>
                    <div class="rightNav-input" style="width: 50%; margin-right: 10px">
                      <input type="text" v-bind:value="
                          '已添加' + dynalt.config.canvas.length + '个'
                        " disabled />
                    </div>
                    <div class="rightNav-button">
                      <mu-button small color="primary" @click="RNoptionEdit($event, 'canvas', -1)">添加</mu-button>
                    </div>
                    <div class="rightNav-text">隐藏画布栏目</div>
                    <div class="rightNav-box" style="border: 1px solid #000;width: 28px;background: #fff;" @click="RNoptionEdit($event, 'nav-enable')">
                      <mu-icon size="20" value="done" color="blue" style="margin: 3px" v-show="dynalt.config.nav.enable"></mu-icon>
                    </div>
                  </div>
                  <div class="rightNav-details">
                    <div></div>
                    <span>导航条设置</span>
                    <div></div>
                  </div>
                  <div class="rightNav-item" v-if="dynalt.config.canvas.length > 0 && canvasCur >= 0">
                    <div class="rightNav-text">修改导航条名称</div>
                    <div class="rightNav-input" style="width: 50%; margin-right: 10px">
                      <input type="text" v-model="dynalt.config.canvas[canvasCur].name" />
                    </div>
                    <div class="rightNav-separate" />
                    <div class="rightNav-text">导航条浮动</div>
                    <div class="rightNav-select" style="width: 50%">
                      <select name id v-model="dynalt.config.nav.float">
                        <option value="outside">相对于页面</option>
                        <option value="inside">相对于画布</option>
                      </select>
                    </div>
                    <div class="rightNav-text">导航条位置</div>
                    <div class="rightNav-select" style="width: 50%">
                      <select name id v-model="dynalt.config.nav.position">
                        <option value="top">上</option>
                        <option value="bottom">下</option>
                        <option value="left">左</option>
                        <option value="right">右</option>
                      </select>
                    </div>
                    <div class="rightNav-separate" />
                    <div class="rightNav-text">导航条背景颜色</div>
                    <div class="rightNav-colorbox">
                      <div class="rightNav-box" :style="'border: 1px solid #000;background:' +dynalt.config.nav.background"
                        @click="RNoptionEdit($event, 'nav-background')"></div>
                    </div>
                    <div class="rightNav-text">导航条文字颜色</div>
                    <div class="rightNav-colorbox">
                      <div class="rightNav-box" :style="'border: 1px solid #000;background:' +dynalt.config.nav.color"
                        @click="RNoptionEdit($event, 'nav-color')">
                      </div>
                    </div>
                    <div class="rightNav-text">导航切换颜色</div>
                    <div class="rightNav-colorbox">
                      <div class="rightNav-box" :style="'border: 1px solid #000;background:' +dynalt.config.nav.checkColor"
                        @click="RNoptionEdit($event, 'nav-checkColor')"></div>
                    </div>
                    <div class="rightNav-separate" />
                    <div class="rightNav-text">画布切换特效</div>
                    <div class="rightNav-select" style="width: 50%">
                      <select name id v-model="dynalt.config.nav.transition">
                        <option value="none">无</option>
                        <option value="fade">淡入淡出</option>
                        <option value="slide">滑入滑出</option>
                        <option value="expand">展开折叠</option>
                        <option value="bounce">缩放</option>
                      </select>
                    </div>
                    <div class="rightNav-separate" />
                  </div>
                </div>
                <div v-if="elementCur>=0">
                  <!-- 交互 -->
                  <div v-if="pElement.type=='active'">
                    <div name="水池" v-if="pElement.style.type == 'active-pool'">
                      <div class="rightNav-item">
                        <div class="rightNav-text">数据流</div>
                        <div class="rightNav-select">
                          <select v-model="pElement.value.stream" @change="streamHandle">
                            <option :value="pElement.value.stream" v-if="pElement.value.stream['api-key']==''">请选择</option>
                            <option v-for=" (item,index) in stream" :key="index" :value="item">{{item.name}}</option>
                          </select>
                        </div>
                        <div class="rightNav-text">标签</div>
                        <div class="rightNav-select">
                          <select v-model="pElement.value.label" @change="labelHandle">
                            <option :value="pElement.value.label" v-if="pElement.value.label.labelID==''">请选择</option>
                            <option v-for="(item,index) in label[pElement.value.stream['api-key']]" :key="index" :value="item">{{item.name}}
                            </option>
                          </select>
                        </div>
                        <div class="rightNav-separate" />
                        <div class="rightNav-text">刷新频率</div>
                        <div class="rightNav-input" style="width: 50%">
                          <input type="text" v-model="pElement.value.cycle" />
                        </div>
                        <div class="rightNav-separate" />
                        <div class="rightNav-text">最大值（峰值）</div>
                        <div class="rightNav-input" style="width: 50%">
                          <input type="text" v-model="pElement.value.max" />
                        </div>
                        <div class="rightNav-text">最小值（谷值）</div>
                        <div class="rightNav-input" style="width: 50%">
                          <input type="text" v-model="pElement.value.min" />
                        </div>
                        <div class="rightNav-separate" />
                        <div class="rightNav-text">显示百分比</div>
                        <div class="rightNav-select" style="width: 50%">
                          <select v-model="pElement.value.show">
                            <option :value="true">是</option>
                            <option :value="false">否</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 组件-数据 -->
                  <div v-if="pElement.type=='data-value'">
                    <div class="rightNav-item">
                      <div class="rightNav-text">数据流</div>
                      <div class="rightNav-select">
                        <select v-model="pElement.value.stream" @change="streamHandle">
                          <option :value="pElement.value.stream" v-if="pElement.value.stream['api-key']==''">请选择</option>
                          <option v-for=" (item,index) in stream" :key="index" :value="item">{{item.name}}</option>
                        </select>
                      </div>
                      <div class="rightNav-text">标签</div>
                      <div class="rightNav-select">
                        <select v-model="pElement.value.label" @change="labelHandle">
                          <option :value="pElement.value.label" v-if="pElement.value.label.labelID==''">请选择</option>
                          <option v-for="(item,index) in label[pElement.value.stream['api-key']]" :key="index" :value="item">{{item.name}}</option>
                        </select>
                      </div>
                      <div class="rightNav-separate" />
                      <div class="rightNav-text">刷新频率</div>
                      <div class="rightNav-input" style="width: 50%">
                        <input type="text" v-model="pElement.value.cycle" />
                      </div>
                      <div class="rightNav-text">显示内容</div>
                      <div class="rightNav-select" style="width: 50%">
                        <select name id v-model="pElement.value.content">
                          <option value="value">数值</option>
                          <option value="time">更新时间</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <!-- 组件-开关 -->
                  <div v-if="pElement.type=='data-switch'">
                    <div class="rightNav-item">
                      <div class="rightNav-text">数据流</div>
                      <div class="rightNav-select">
                        <select v-model="pElement.value.stream" @change="streamHandle">
                          <option :value="pElement.value.stream" v-if="pElement.value.stream['api-key']==''">请选择</option>
                          <option v-for=" (item,index) in stream" :key="index" :value="item">{{item.name}}</option>
                        </select>
                      </div>
                      <div class="rightNav-text">标签</div>
                      <div class="rightNav-select">
                        <select v-model="pElement.value.label" @change="labelHandle">
                          <option :value="pElement.value.label" v-if="pElement.value.label.labelID==''">请选择</option>
                          <option v-for="(item,index) in label[pElement.value.stream['api-key']]" :key="index" :value="item">{{item.name}}</option>
                        </select>
                      </div>
                      <div class="rightNav-separate" />
                      <div class="rightNav-text">刷新频率</div>
                      <div class="rightNav-input" style="width: 50%">
                        <input type="text" v-model="pElement.value.cycle" />
                      </div>
                      <div class="rightNav-separate" />
                      <div class="rightNav-text">自定义图片（开）</div>
                      <div style="height:60px;width:100%;display:flex">
                        <div class="rightNav-select" style="width:50%;display:inline-block;margin-top:15px">
                          <select v-model="pElement.value.openImg">
                            <option :value="require('../assets/open.svg')">默认</option>
                            <option v-for="(item,index) in LNoption.image" :key="index" :value="item">{{item.split('/')[item.split('/').length-1]}}
                            </option>
                          </select>
                        </div>
                        <img :src="pElement.value.openImg" style="height:60px;margin-left:20px">
                      </div>
                      <div class="rightNav-separate" />
                      <div class="rightNav-text">自定义图片（关）</div>
                      <div style="height:60px;width:100%;display:flex">
                        <div class="rightNav-select" style="width:50%;display:inline-block;margin-top:15px">
                          <select v-model="pElement.value.closeImg">
                            <option :value="require('../assets/close.svg')">默认</option>
                            <option v-for="(item,index) in LNoption.image" :key="index" :value="item">{{item.split('/')[item.split('/').length-1]}}
                            </option>
                          </select>
                        </div>
                        <img :src="pElement.value.closeImg" style="height:60px;margin-left:20px">
                      </div>
                      <div class="rightNav-separate" />
                      <div class="rightNav-text">自定义图片（异常）</div>
                      <div style="height:60px;width:100%;display:flex">
                        <div class="rightNav-select" style="width:50%;display:inline-block;margin-top:15px">
                          <select v-model="pElement.value.errorImg">
                            <option :value="require('../assets/error.svg')">默认</option>
                            <option v-for="(item,index) in LNoption.image" :key="index" :value="item">{{item.split('/')[item.split('/').length-1]}}
                            </option>
                          </select>
                        </div>
                        <img :src="pElement.value.errorImg" style="height:60px;margin-left:20px">
                      </div>
                    </div>
                  </div>
                  <!-- 组件-控制 -->
                  <div v-if="pElement.type=='data-control'">
                    <div class="rightNav-item">
                      <div class="rightNav-text">数据流</div>
                      <div class="rightNav-select">
                        <select v-model="pElement.value.stream" @change="streamHandle">
                          <option :value="pElement.value.stream" v-if="pElement.value.stream['api-key']==''">请选择</option>
                          <option v-for=" (item,index) in stream" :key="index" :value="item">{{item.name}}</option>
                        </select>
                      </div>
                      <div class="rightNav-text">标签</div>
                      <div class="rightNav-select">
                        <select v-model="pElement.value.label" @change="labelHandle">
                          <option :value="pElement.value.label" v-if="pElement.value.label.labelID==''">请选择</option>
                          <option v-for="(item,index) in label[pElement.value.stream['api-key']]" :key="index" :value="item">{{item.name}}</option>
                        </select>
                      </div>
                      <div class="rightNav-separate" />
                      <div class="rightNav-text">自定义图片</div>
                      <div style="height:60px;width:100%;display:flex">
                        <div class="rightNav-select" style="width:50%;display:inline-block;margin-top:15px">
                          <select v-model="pElement.value.img">
                            <option :value="require('../assets/control.svg')">默认</option>
                            <option v-for="(item,index) in LNoption.image" :key="index" :value="item">{{item.split('/')[item.split('/').length-1]}}
                            </option>
                          </select>
                        </div>
                        <img :src="pElement.value.img" style="height:60px;margin-left:20px">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>

    <!-- 调色盘 -->
    <mu-slide-right-transition>
      <div class="pc-color" v-if="color.enable" :style="'top:' + color.top + 'px;left:' + color.left + 'px;'">
        <v-color style="box-shadow: none; background: none" :isGradient="true" v-model="color.value" :disableAlpha="color.alpha"
          @input="colorHandle('input')" />
        <div style="text-align: center; padding-bottom: 5px">
          <mu-button fab small color="pink" style="margin-right: 40px; height: 34px; width: 34px" @click="colorHandle('clear')">
            <mu-icon value="clear"></mu-icon>
          </mu-button>
          <mu-button fab small color="primary" style="height: 34px; width: 34px" @click="colorHandle('check')">
            <mu-icon value="check"></mu-icon>
          </mu-button>
        </div>
      </div>
    </mu-slide-right-transition>
    <!-- 素材拖块 -->
    <div class="pc-drag" :style="getdragBox()" v-if="dragBox.enable">
      <div v-if="drag.from == 'base'" :class="'leftNav-' + drag.from">
        <div>
          <mu-icon size="40" color="grey700" :value="drag.config.index"></mu-icon>
        </div>
        <span>{{ drag.config.item }}</span>
      </div>
      <div v-if="drag.from == 'module'" :class="'leftNav-' + drag.from">
        <img :src="drag.config.img" draggable="false" />
        <div>{{ drag.config.title }}</div>
      </div>
      <div v-if="drag.from == 'material'" :class="'leftNav-' + drag.from">
        <img :src="drag.config" draggable="false" />
      </div>
      <div v-if="drag.from == 'active'" :class="'leftNav-' + drag.from">
        <img :src="drag.config.img" draggable="false" />
        <div>{{ drag.config.title }}</div>
      </div>
      <div v-if="drag.from == 'image'" :class="'leftNav-' + drag.from">
        <div>
          <img :src="drag.config" draggable="false" />
        </div>
        <span>{{
          drag.config.split("/")[drag.config.split("/").length - 1]
        }}</span>
      </div>
    </div>
    <!-- 右键菜单 -->
    <mu-expand-transition>
      <div class="pc-menu" v-if="menu.enable" :style="'top:'+menu.pos.y+'px;left:'+menu.pos.x+'px;'" @contextmenu.prevent="'return'">
        <div class="pc-menu-item" v-for="(item,index) in menu.list" :key="index" v-show="item.show"
          :style="(item.enable?'':'color:#bfc5d1;cursor:no-drop;')+(item.border?'border-bottom: 1px solid #dfe2e9;':'')" @click.stop="menuItemClick(item)">
          {{item.title}}
          <span>{{item.prompt}}</span>
        </div>
      </div>
    </mu-expand-transition>
    <!-- 下发控制 -->
    <mu-expand-transition>
      <div class="pc-control" v-if="control.enable">
        <div class="pc-control-head">
          <span>下发数据</span> {{control.item.value.label.name == ""?"未绑定数据":control.item.value.label.name}}
        </div>
        <div class="pc-control-body">
          <div class="pc-control-view">
            <div class="pc-control-view-item" v-for="(item,index) in control.log" :key="index">
              发送数据：{{item.value}}
              <span style="float:right">{{getTime(item.time)}}</span>
              <span style="float:right;margin-right:10px">{{item.msg}}</span>
            </div>
          </div>
          <textarea rows="3" v-model="control.value"></textarea>
          <div class="pc-control-btn">
            <mu-button small color="grey50" @click="control_Handle('cancel')" style="color:#000">关闭</mu-button>
            <mu-button small color="primary" @click="control_Handle('send')">发送</mu-button>
          </div>
        </div>
      </div>
    </mu-expand-transition>
  </div>
</template>

<script>
import { dynalt_Retrieve } from "../network/dynalt.js";
import {
  tolink_Stream,
  tolink_Label,
  tolink_Realtime,
  tolink_Mqttwrite,
} from "../network/tolink.js";
import { Sketch } from "vue-color";

import {
  dynalt_Config,
  dynalt_Update,
  dynalt_Material_Private,
  dynalt_Image_Upload,
  dynalt_Image_List,
  dynalt_Image_Delete,
} from "../network/dynalt.js";

import {
  funcUL,
  LNoption,
  menu,
  textFields,
  control,
  regPos,
  regNeg,
  getUrlKey,
} from "../assets/option.js";

import screenfull from "screenfull";

let lodash = require("lodash");

export default {
  components: {
    "v-color": Sketch,
  },
  data() {
    return {
      token: "",
      id: "",
      url: "",
      dynalt: {},
      realtime: { update: 0 },

      stream: [],
      label: [],
      apiKeyCur: "",

      viewLock: "",

      rightNavHidden: true,
      funcULCur: -1,
      rightNavCur: true,
      centerShow: false,

      RNoption: {
        editEnable: true,
        auxLine: true,
      },

      canvasCur: 0,
      elementCur: -1,

      color: {
        enable: false,
        value: "#fff",
        alpha: false,
        type: "hex8",
        cache: "",
        pointer: {},
        pkey: "",
        top: 0,
        left: 0,
      },
      mouse: {
        pos: { x: 0, y: 0 },
        click: { enbale: false, x: 0, y: 0 },
        move: { x: 0, y: 0 },
      },
      board: {
        enable: false,
        top: 60,
        left: 300,
        x: 0,
        y: 0,
      },
      drag: {
        id: "",
        from: "",
        config: {},
      },
      dragBox: {
        enable: false,
        top: 0,
        left: 0,
        x: 0,
        y: 0,
        r: 0,
      },
      eleBox: {
        enable: false,
        action: "",
        pointer: null,
        cursor: "",
        x: 0,
        y: 0,
        w: 0,
        h: 0,
      },

      funcUL,
      LNoption,
      menu,
      textFields,
      regPos,
      regNeg,
      control,

      time: {
        unix: 0,
        local: "now time",
      },
      windowWidth: document.documentElement.clientWidth,
      windowHeight: document.documentElement.clientHeight,
    };
  },
  watch: {
    funcULCur() {
      switch (this.funcULCur) {
        case 2:
          this.dynaltMaterialPrivate();
          break;
        case 4:
          this.dynaltImageList(this.id);
          break;
      }
    },
    elementCur() {
      this.rightNavCur = true;
      if ("value" in this.pElement) {
        if (typeof this.pElement.value == "object") {
          if ("stream" in this.pElement.value) {
            if (this.pElement.value.stream["api-key"] !== this.apiKeyCur) {
              this.apiKeyCur = this.pElement.value.stream["api-key"];
              this.tolinkLabel(this.pElement.value.stream["api-key"]);
            }
          }
        }
      }
    },
  },
  mounted() {
    this.id = getUrlKey("id");
    this.token = getUrlKey("token");
    this.url = document.URL;

    this.dynaltRetrieve(this.id);
    this.tolinkStream(this.token);

    this.dynaltMaterialPrivate();
    this.dynaltImageList(this.id);

    setInterval(() => {
      this.time.unix = new Date().getTime() / 1000;
      this.time.local = this.getDatetime();
    }, 1000);

    window.onresize = () => {
      return (() => {
        this.windowHeight = document.documentElement.clientHeight;
        this.windowWidth = document.documentElement.clientWidth;
      })();
    };

    setInterval(this.activeHandle, 10);
    setInterval(this.dataHandle, 1000);

    setTimeout(() => {
      this.rightNavHidden = false;
    }, 100);
    setTimeout(() => {
      this.funcULCur = 0;
    }, 200);
    setTimeout(() => {
      this.centerShow = true;
    }, 650);
  },
  methods: {
    /* - - - - - - - */

    funcHandle(func) {
      switch (func) {
        case "save":
          let config = lodash.cloneDeep(this.dynalt.config);
          for (let idx in config.canvas) {
            for (let idx2 in config.canvas[idx].element) {
              if ("value" in config.canvas[idx].element[idx2]) {
                if (typeof config.canvas[idx].element[idx2].value == "object") {
                  if ("update" in config.canvas[idx].element[idx2].value) {
                    config.canvas[idx].element[idx2].value.update = false;
                  }
                }
              }
            }
          }
          this.dynaltConfig(this.dynalt.id, config);
          break;
        case "release":
          this.dynaltUpdate({
            id: this.dynalt.id,
            name: this.dynalt.name,
            password: this.dynalt.password,
            public: this.dynalt.public,
            release: true,
          });
          break;
        case "view":
          let routeUrl = this.$router.resolve({
            path: "/board",
            query: { id: this.dynalt.id },
          });
          window.open(routeUrl.href, "_blank");
          break;
      }
    },

    /* - - - - - - - */

    fullscreen_Event() {
      screenfull.toggle();
    },
    replay_Event() {
      window.location.href = this.url;
    },
    switchvideo_Event(idx) {
      if (idx >= 0) {
        this.canvasCur = idx;
        this.elementCur = -1;
      }
    },
    link_Event(url) {
      window.open(url);
    },
    switch_Event(item, val) {
      if (
        item.value.stream["api-key"] == "" ||
        item.value.label.labelID == ""
      ) {
        this.$alert("开关未绑定数据", "提示", {
          okLabel: "知道了",
        });
        return;
      }
      this.$confirm(
        (val == 0 ? "关闭 " : "开启 ") + item.value.label.name + "？",
        "提示",
        {}
      ).then(({ result }) => {
        if (result) {
          this.tolinkMqttwrite(
            item.value.stream["api-key"],
            item.value.label.labelID,
            val
          );
        }
      });
    },
    control_Event(item) {
      this.control = { enable: true, item, value: "", log: [] };
    },
    control_Handle(btn) {
      switch (btn) {
        case "send":
          if (
            this.control.item.value.stream["api-key"] == "" ||
            this.control.item.value.label.labelID == ""
          ) {
            return;
          }
          if (
            !this.regPos.test(this.control.value) &&
            !this.regNeg.test(this.control.value)
          ) {
            this.control.log.unshift({
              value: this.control.value,
              time: Math.round(new Date().getTime() / 1000),
              msg: "请输入数字",
            });
            return;
          }
          this.tolinkMqttwrite(
            this.control.item.value.stream["api-key"],
            this.control.item.value.label.labelID,
            parseFloat(this.control.value),
            true
          );
          break;
        case "cancel":
          this.control = { enable: false, item: null, value: "", log: [] };
          break;
      }
    },
    editNav_Event(func, idx) {
      switch (func) {
        case "show":
          this.elementCur = -1;
          this.canvasCur = idx;
          break;
        case "delete":
          this.$confirm("确认删除画布 “" + this.pCanvas.name + "” ？", {}).then(
            ({ result }) => {
              if (result) {
                this.dynalt.config.canvas.splice(idx, 1);
                this.canvasCur = 0;
                console.log(this.dynalt.config.canvas)
              }
            }
          );
          break;
      }
    },

    /* - - - - - - - */

    streamHandle() {
      this.pElement.value.update = false;
      this.pElement.value.label = { labelID: "" };
      if (this.pElement.value.stream["api-key"] !== this.apiKeyCur) {
        this.apiKeyCur = this.pElement.value.stream["api-key"];
        this.tolinkLabel(this.pElement.value.stream["api-key"]);
      }
    },
    labelHandle() {
      this.pElement.value.update = false;
    },
    dataHandle() {
      if (Object.keys(this.dynalt).length == 0) return;
      let request = {};
      let cycle = 0;
      let timeNow = parseInt(new Date().getTime() / 1000);

      for (let canvas of this.dynalt.config.canvas) {
        for (let element of canvas.element) {
          switch (element.type) {
            case "data-value":
            case "data-switch":
            case "active":
              if (element.type == "active") {
                switch (element.style.type) {
                  case "active-pool":
                    break;
                  default:
                    continue;
                }
              }
              cycle =
                Math.trunc(element.value.cycle) < 3 ? 3 : element.value.cycle;

              if (
                (timeNow % cycle == 0 || !element.value.update) &&
                element.value.stream["api-key"] !== "" &&
                element.value.label["labelID"] !== ""
              ) {
                element.value.update = true;
                if (!(element.value.stream["api-key"] in request)) {
                  request[element.value.stream["api-key"]] = [];
                }
                let exist = false;
                for (let labelID of request[element.value.stream["api-key"]]) {
                  if (labelID == element.value.label.labelID) {
                    exist = true;
                    break;
                  }
                }
                if (!exist) {
                  request[element.value.stream["api-key"]].push(
                    element.value.label.labelID
                  );
                }
              }
              break;
          }
        }
      }

      if (Object.keys(request).length > 0) {
        for (let index in request) {
          this.tolinkRealtime(index, request[index]);
        }
      }
    },

    /* - - - - - - - */

    activeHandle() {
      if (Object.keys(this.dynalt).length == 0) return;
      for (let canvas of this.dynalt.config.canvas) {
        for (let element of canvas.element) {
          if (element.type == "active") {
            switch (element.style.type) {
              case "active-pipe":
                this.active_pipeHandle(element);
                break;
              case "active-pool": // 水池
                this.active_poolHandle(element);
                break;
            }
          }
        }
      }
    },
    active_pipeHandle(ele) {
      let canvas = document.getElementById(ele.style.id);
      if (canvas == undefined) return;
      var context = canvas.getContext("2d");

      ele.style.move += 0.6;
      if (ele.style.move >= ele.box.height * 3) {
        ele.style.move = 0;
      }

      context.clearRect(0, 0, ele.box.width, ele.box.height);
      context.lineWidth = 0.01;
      context.shadowOffsetX = 0;
      context.shadowOffsetY = 0;
      context.shadowBlur = 0;
      context.shadowColor = "RGB(42, 154, 199)";

      let gradient = context.createLinearGradient(
        0,
        0,
        0,
        ele.box.height * 0.5
      );
      gradient.addColorStop(0, "#8c96aa");
      gradient.addColorStop(1, "#ffffff");

      let gradient2 = context.createLinearGradient(
        0,
        ele.box.height * 0.5,
        0,
        ele.box.height
      );
      gradient2.addColorStop(0, "#ffffff");
      gradient2.addColorStop(1, "#8c96aa");

      context.fillStyle = gradient;
      context.fillRect(0, 0, ele.box.width, ele.box.height * 0.5);

      context.fillStyle = gradient2;
      context.fillRect(
        0,
        ele.box.height * 0.5,
        ele.box.width,
        ele.box.height * 0.5
      );

      context.shadowBlur = 3;
      context.fillStyle = ele.style.color;

      for (let idx = -1; idx < ele.box.width / (ele.box.height * 3); idx++) {
        context.fillRect(
          idx * ele.box.height * 3 + ele.style.move,
          ele.box.height * 0.17,
          ele.box.height * 2,
          ele.box.height * 0.66
        );
      }

      context.fill();
    },
    active_poolHandle(ele) { // 水池
      let canvas = document.getElementById(ele.style.id);
      if (canvas == undefined) return;
      let context = canvas.getContext("2d");

      let range = 0;
      let show = "";
      let vaule = this.dataShow(
        this.realtime[ele.value.label.labelID],
        ele.value.content,
        this.realtime.update
      );

      switch (vaule) {
        case "暂无":
        case "异常":
          range = ele.value.max / 100;
          show = vaule;
          break;
        default:
          range = (vaule - ele.value.min) / (ele.value.max - ele.value.min);
          show = Math.trunc(range * 100) + "%";
      }

      if (range < 0) {
        range = 0;
        show = "<0%";
      }
      if (range > 1) {
        range = 1;
        show = ">100%";
      }
      if (ele.value.max <= ele.value.min) {
        range = 0;
        show = "峰值？";
      }

      ele.style.move = ele.style.move > 100 ? 0 : ele.style.move + 0.05;

      context.clearRect(0, 0, ele.box.width, ele.box.height);
      context.beginPath();

      let points = [];
      for (var x = 0; x < 0 + ele.box.width; x += 20 / ele.box.width) {
        var y = -Math.sin((0 + x) * 0.01 + ele.style.move);
        var dY = ele.box.height * (1 - range);
        points.push([x, dY + y * 6]);
        context.lineTo(x, dY + y * 6);
      }

      context.lineTo(ele.box.width, ele.box.height);
      context.lineTo(0, ele.box.height);
      context.lineTo(points[0][0], points[0][1]);
      context.fillStyle = ele.style.waveColor;
      context.fill();
      context.restore();

      context.textAlign = "center";
      context.fillStyle = ele.style.color;
      context.font = ele.style.fontSize + "px wryh";
      context.fillText(
        ele.value.show ? show : "",
        ele.box.width / 2,
        ele.box.height / 2
      );
    },

    /* - - - - - - - */

    mouseDown(event) {
      if (event.button == 0) {
        this.mouse.click = { enable: true, x: event.x, y: event.y };
      }
    },
    mouseUp(event) {
      if (this.mouse.click.enable) {
        this.mouse.click = { enable: false, x: 0, y: 0 };
        this.mouse.move = { x: 0, y: 0 };
      }

      if (this.board.enable) {
        this.board.enable = false;
      }
      if (this.dragBox.enable) {
        this.dragBox.enable = false;
        if (this.mouse.pos.x < 300 || this.mouse.pos.y < 60) return;
        let ele = null;
        let top =
          this.dragBox.top +
          this.$refs.pcEdit.scrollTop -
          (this.board.top + 50);
        let left =
          this.dragBox.left +
          this.$refs.pcEdit.scrollLeft -
          (this.board.left + 60);
        switch (this.drag.from) {
          case "base":
            ele = this.createBase(this.drag.id, top, left);
            break;
          case "module":
            ele = this.createModule(this.drag.id, top, left);
            break;
          case "material":
            ele = this.createMaterial(this.drag.id, top, left);
            break;
          case "active":
            ele = this.createActive(this.drag.id, top, left);
            break;
          case "image":
            ele = this.createImage(this.drag.id, top, left);
            break;
          default:
            return;
        }
        if (ele == null) return;
        this.pCanvas.element.push(ele);
        this.elementCur = this.pCanvas.element.length - 1;
      }
      if (this.eleBox.enable) {
        this.eleBox.enable = false;
        this.eleBox.cursor = "";
      }
    },
    mouseMove(event) {
      this.mouse.pos.x = event.x;
      this.mouse.pos.y = event.y;

      if (this.mouse.click.enable) {
        this.mouse.move = {
          x: this.mouse.pos.x - this.mouse.click.x,
          y: this.mouse.pos.y - this.mouse.click.y,
        };
      }

      if (this.board.enable) {
        this.board.top = this.board.y + this.mouse.move.y;
        this.board.left = this.board.x + this.mouse.move.x;
      }

      if (this.dragBox.enable) {
        this.dragBox.top = this.dragBox.y + this.mouse.move.y;
        this.dragBox.left = this.dragBox.x + this.mouse.move.x;
      }

      if (this.eleBox.enable) {
        let box = this.eleBox.pointer;
        this.eleBox.y = parseInt(this.eleBox.y);
        this.eleBox.x = parseInt(this.eleBox.x);
        switch (this.eleBox.action) {
          case "element":
            box.top = this.eleBox.y + this.mouse.move.y;
            box.left = this.eleBox.x + this.mouse.move.x;
            break;
          case "rotate":
            const radians = Math.atan2(
              this.mouse.pos.x -
                (60 + this.board.left + this.eleBox.x + this.eleBox.w / 2),
              this.mouse.pos.y -
                (60 + this.board.top + this.eleBox.y + this.eleBox.h / 2)
            );
            box.rotate = Math.trunc(radians * (180 / Math.PI) * -1 + 180);
            break;
          default:
            if (this.eleBox.action.indexOf("n") !== -1) {
              box.top =
                this.mouse.pos.y -
                (this.board.top - this.$refs.pcEdit.scrollTop + (60 - 10));
              box.height = this.eleBox.h - this.mouse.move.y;
            }
            if (this.eleBox.action.indexOf("e") !== -1) {
              box.width =
                this.mouse.pos.x -
                (this.eleBox.x +
                  this.board.left -
                  this.$refs.pcEdit.scrollLeft +
                  60 +
                  5);
            }
            if (this.eleBox.action.indexOf("s") !== -1) {
              box.height =
                this.mouse.pos.y -
                (this.eleBox.y +
                  this.board.top -
                  this.$refs.pcEdit.scrollTop +
                  60 +
                  10);
            }
            if (this.eleBox.action.indexOf("w") !== -1) {
              box.left =
                this.mouse.pos.x -
                (this.board.left - this.$refs.pcEdit.scrollLeft + 60 - 10);
              box.width = this.eleBox.w - this.mouse.move.x;
            }
            box.top = Math.trunc(
              box.top - (this.eleBox.y + this.eleBox.h - 10) > 0
                ? this.eleBox.y + this.eleBox.h - 10
                : box.top
            );
            box.left = Math.trunc(
              box.left - (this.eleBox.x + this.eleBox.w - 10) > 0
                ? this.eleBox.x + this.eleBox.w - 10
                : box.left
            );
            box.width = Math.trunc(box.width < 10 ? 10 : box.width);
            box.height = Math.trunc(box.height < 10 ? 10 : box.height);
        }
      }
    },

    /* - - - - - - - */

    createBase(id, top, left) {
      let ele = {
        type: id,
        box: {
          width: "160",
          height: "40",
          top,
          left,
          rotate: 0,
          lock: false,
          background: "#FFFFFF00",
        },
        style: {
          fontSize: "12",
          fontFamily: "wryh",
          lineHeight: "1",
          textAlign: "left",
          color: "#000000",
          fontWeight: "normal",
          fontStyle: "normal",
          textDecoration: "none",
        },
      };
      switch (id) {
        case "text_fields":
          ele.value = "字体";
          break;
        case "date_range":
          ele.value = this.time;
          break;
        case "link":
          ele.value = { name: "超链接", to: "https://cn.bing.com" };
          break;
        case "replay":
          ele.value = "刷新页面";
          break;
        case "switch_video":
          ele.value = { name: "栏目", to: -1 };
          break;
        case "web":
          ele.box.width = "600";
          ele.box.height = "300";
          delete ele.style;
          ele.value = "https://cn.bing.com/";
          break;
        case "fullscreen":
          ele.box.width = "30";
          ele.box.height = "30";
          delete ele.style;
          ele.value = false;
          break;
      }
      return ele;
    },
    createMaterial(url, top, left) {
      let ele = {
        type: "material",
        box: {
          width: "103",
          height: "116",
          top,
          left,
          rotate: 0,
          lock: false,
          background: "#FFFFFF00",
        },
        value: url,
      };
      return ele;
    },
    createImage(url, top, left) {
      let ele = {
        type: "image",
        box: {
          width: "105",
          height: "118",
          top,
          left,
          rotate: 0,
          lock: false,
          background: "#FFFFFF00",
        },
        value: url,
      };
      return ele;
    },
    createActive(id, top, left) {
      let ele = {
        type: "active",
        box: {
          width: "300",
          height: "260",
          top,
          left,
          rotate: 0,
          lock: false,
          background: "#FFFFFF00",
        },
        style: { type: id, id: new Date().getTime(), move: 0 },
      };
      switch (id) {
        case "active-pipe":
          ele.box.width = "400";
          ele.box.height = "20";
          ele.style.color = "#2a9ac7ff";
          break;
        case "active-pool":
          ele.style.waveColor = "#1c86d1ff";
          ele.style.color = "#065580ff";
          ele.style.fontSize = 20;
          ele.value = {
            update: false,
            show: false,
            content: "value",
            cycle: 3,
            max: 90,
            min: 0,
            stream: { "api-key": "" },
            label: { labelID: "" },
          };
          break;
        default:
          return null;
      }
      return ele;
    },
    createModule(id, top, left) {
      let ele = {
        type: id,
        box: {
          width: "105",
          height: "105",
          top,
          left,
          rotate: 0,
          lock: false,
          background: "#FFFFFF00",
        },
      };
      switch (id) {
        case "data-value":
          ele.box.width = "160";
          ele.box.height = "40";
          ele.style = {
            fontSize: "12",
            fontFamily: "wryh",
            lineHeight: "1",
            textAlign: "left",
            color: "#000000",
            fontWeight: "normal",
            fontStyle: "normal",
            textDecoration: "none",
          };
          ele.value = {
            update: false,
            content: "value",
            cycle: 3,
            stream: { "api-key": "" },
            label: { labelID: "" },
          };
          break;
        case "data-switch":
          ele.value = {
            update: false,
            cycle: 3,
            openImg: require("../assets/open.svg"),
            closeImg: require("../assets/close.svg"),
            errorImg: require("../assets/error.svg"),
            stream: { "api-key": "" },
            label: { labelID: "" },
          };
          break;
        case "data-control":
          ele.box.width = "50";
          ele.box.height = "50";
          ele.value = {
            img: require("../assets/control.svg"),
            stream: { "api-key": "" },
            label: { labelID: "", name: "" },
          };
          break;
        default:
          return null;
      }
      return ele;
    },

    /* - - - - - - - */

    editCenterStyle() {
      let styleStr = "";

      styleStr += "background:";
      styleStr += this.dynalt.config.canvas[this.canvasCur].background + ";";

      styleStr += !this.RNoption.editEnable ? "cursor: move;" : "";
      styleStr += "top:" + this.board.top + "px;";
      styleStr += "left:" + this.board.left + "px;";
      styleStr += "cursor:" + this.eleBox.cursor + ";";
      styleStr += "width:" + this.dynalt.config.board.width + "px;";
      styleStr += "height:" + this.dynalt.config.board.height + "px;";

      return styleStr;
    },
    elementBoxStyle(box, idx) {
      let styleStr = "";
      styleStr += "width:" + box.width + "px;";
      styleStr += "height:" + box.height + "px;";
      styleStr += "top:" + box.top + "px;";
      styleStr += "left:" + box.left + "px;";
      styleStr += "z-index:" + idx + ";";
      styleStr += "transform:rotate(" + Math.trunc(box.rotate) + "deg);";
      styleStr += "background:" + box.background + ";";
      return styleStr;
    },
    elementClick(event, idx) {
      this.elementCur = idx;
      this.menu.enable = false;
      if (!this.RNoption.editEnable || this.elementCur < 0) {
        this.elementCur = -1;
        return;
      }
      switch (event.button) {
        case 0:
          if (this.pElement.box.lock) return;
          this.eleBox = {
            enable: true,
            action: "element",
            pointer: this.pElement.box,
            x: this.pElement.box.left,
            y: this.pElement.box.top,
            w: this.pElement.box.width,
            h: this.pElement.box.height,
            r: 0,
          };
          break;
        case 2:
          this.menu.enable = true;
          this.menu.pos = { x: this.mouse.pos.x, y: this.mouse.pos.y };
          this.menu.list[2].enable =
            this.elementCur >= this.pCanvas.element.length - 1 ? false : true;
          this.menu.list[3].enable = this.elementCur < 1 ? false : true;
          this.menu.list[4].enable =
            this.elementCur >= this.pCanvas.element.length - 1 ? false : true;
          this.menu.list[5].enable = this.elementCur < 1 ? false : true;
          for (let item of this.menu.list) {
            item.show = !this.pElement.box.lock;
          }
          this.menu.list[7].show = this.pElement.box.lock;
          break;
      }
    },
    elementStyle(item) {
      let styleStr = "";
      switch (item.type) {
        default:
          for (let idx in item.style) {
            switch (idx) {
              case "fontSize":
                styleStr += idx + ":" + item.style[idx] + "px;";
                break;
              case "lineHeight":
                if (item.style[idx] == "0")
                  styleStr += idx + ":" + item.box.height + "px;";
                else styleStr += idx + ":" + item.style[idx] + ";";
                break;
              default:
                styleStr += idx + ":" + item.style[idx] + ";";
            }
          }
          break;
      }
      return styleStr;
    },
    resizableClick(event, action, cursor) {
      if (this.elementCur < 0 || !this.RNoption.editEnable || event.button !== 0)
        return;
      this.eleBox = {
        enable: true,
        action,
        cursor,
        pointer: this.pElement.box,
        x: this.pElement.box.left,
        y: this.pElement.box.top,
        w: this.pElement.box.width,
        h: this.pElement.box.height,
        r: 0,
      };
    },

    menuItemClick(item) {
      if (item.enable == false) return;
      let cacheEle = null;
      switch (item.title) {
        case "复制":
          let ele = lodash.cloneDeep(this.pElement);
          ele.box.top = parseInt(ele.box.top) + 30;
          ele.box.left = parseInt(ele.box.left) + 30;
          this.pCanvas.element.push(ele);
          this.elementCur = this.pCanvas.element.length - 1;
          break;
        case "上移一层":
          cacheEle = lodash.cloneDeep(
            this.pCanvas.element[this.elementCur + 1]
          );
          this.$set(
            this.pCanvas.element,
            this.elementCur + 1,
            lodash.cloneDeep(this.pElement)
          );
          this.$set(this.pCanvas.element, this.elementCur, cacheEle);
          this.elementCur += 1;
          break;
        case "下移一层":
          cacheEle = lodash.cloneDeep(
            this.pCanvas.element[this.elementCur - 1]
          );
          this.$set(
            this.pCanvas.element,
            this.elementCur - 1,
            lodash.cloneDeep(this.pElement)
          );
          this.$set(this.pCanvas.element, this.elementCur, cacheEle);
          this.elementCur -= 1;
          break;
        case "置于顶层":
          cacheEle = lodash.cloneDeep(this.pElement);
          this.pCanvas.element.splice(this.elementCur, 1);
          this.pCanvas.element.push(cacheEle);
          this.elementCur = this.pCanvas.element.length - 1;
          break;
        case "置于底层":
          cacheEle = lodash.cloneDeep(this.pElement);
          this.pCanvas.element.splice(this.elementCur, 1);
          this.pCanvas.element.unshift(cacheEle);
          this.elementCur = 0;
          break;
        case "删除":
          this.pCanvas.element.splice(this.elementCur, 1);
          this.elementCur = -1;
          break;
        case "锁定":
          this.pElement.box.lock = true;
          break;
        case "解锁":
          this.pElement.box.lock = false;
          break;
      }
      this.menu.enable = false;
    },

    /* - - - - - - - */

    editCenterClick(event) {
      if (event.button == 0 && !this.RNoption.editEnable) {
        this.board = {
          enable: true,
          top: this.board.top,
          left: this.board.left,
          x: this.board.left,
          y: this.board.top,
        };
      }
    },
    leftNavClick(event, id, from, config) {
      let p = event.currentTarget.getBoundingClientRect();
      this.drag = { id, from, config };
      this.dragBox = { enable: true, top: p.y, left: p.x, x: p.x, y: p.y };
    },
    getdragBox() {
      return "top:" + this.dragBox.top + "px;left:" + this.dragBox.left + "px";
    },

    /* - - - - - - - */

    funcULClick(index) {
      this.funcULCur = this.funcULCur == index ? -1 : index;
    },
    rightNavSwitch(val) {
      this.rightNavCur = val;
    },
    rightNavHiddenEvent() {
      this.rightNavHidden = !this.rightNavHidden;
    },
    editNavShow(mode) {
      return (
        this.dynalt.config.canvas.length > 1 &&
        this.dynalt.config.nav.float == mode &&
        !this.dynalt.config.nav.enable
      );
    },
    editNavStyle() {
      let styleStr = "";

      styleStr += "background:" + this.dynalt.config.nav.background + ";";

      switch (this.dynalt.config.nav.position) {
        case "top":
          styleStr += "top:0; left:0; width:100%; height:40px;";
          styleStr += "overflow-x:auto; overflow-y:hidden;";
          break;
        case "bottom":
          styleStr += "bottom:0; left:0; width:100%; height:40px;";
          styleStr += "overflow-x:auto; overflow-y:hidden;";
          break;
        case "left":
          styleStr += "top:0; left:0; height:100%;";
          styleStr += "overflow-x:hidden; overflow-y:auto;";
          break;
        case "right":
          styleStr += "top:0; right:0; height:100%;";
          styleStr += "overflow-x:hidden; overflow-y:auto;";
          break;
      }

      return styleStr;
    },
    editNavItemStyle(idx) {
      let styleStr = "";

      styleStr += "color:" + this.dynalt.config.nav.color + ";";
      styleStr +=
        this.canvasCur == idx
          ? "background:" + this.dynalt.config.nav.checkColor + ";"
          : "";
      switch (this.dynalt.config.nav.position) {
        case "top":
        case "bottom":
          styleStr += "display: inline-block;";
          break;
        case "left":
        case "right":
          break;
      }

      return styleStr;
    },

    /* - - - - - - - */

    RNoptionEdit(event, key, val) { // 设置颜色
      const p = event.target.getBoundingClientRect();
      switch (key) {
        case "nav-background":
        case "nav-color":
        case "nav-checkColor":
          this.colorEnable(
            this.dynalt.config[key.split("-")[0]],
            key.split("-")[1],
            p.top,
            p.left
          );
          break;
        case "nav-enable":
          this.dynalt.config.nav.enable = !this.dynalt.config.nav.enable;
          break;
        case "canvas":
          if (val == -1) {
            this.dynalt.config.canvas.push({
              name: "画布" + (this.dynalt.config.canvas.length + 1),
              background: "#fff",
              element: [],
            });
            this.canvasCur = this.dynalt.config.canvas.length - 1;
          } else {
            if (event.button == 2) {
              setTimeout(() => {
                this.$confirm(
                  "确定删除 " + this.dynalt.config.canvas[val].name + "？",
                  "提示",
                  {}
                ).then(({ result }) => {
                  if (result) {
                    this.canvasCur =
                      this.canvasCur > this.dynalt.config.canvas.length - 2
                        ? this.dynalt.config.canvas.length - 2
                        : this.canvasCur;
                    this.dynalt.config.canvas.splice(val, 1);
                  }
                });
              }, 150);
            }
          }
          break;
        case "canvas-background":
          let p2 = event.target.getBoundingClientRect();
          this.colorEnable(
            this.dynalt.config[key.split("-")[0]][val],
            key.split("-")[1],
            p2.top,
            p2.left
          );
          break;
        case "style-color":
        case "style-waveColor":
        case "box-background":
          this.colorEnable(
            this.pElement[key.split("-")[0]],
            key.split("-")[1],
            p.top,
            p.left
          );
          break;
        case "style-fontWeight":
        case "style-fontStyle":
        case "style-textDecoration":
        case "box-lock":
          this.pElement[key.split("-")[0]][key.split("-")[1]] = val;
          break;
        default:
          this.RNoption[key] = val;
      }
    },
    leftNavEdit(event, key) {
      switch (key) {
        case "image":
          let name = event.target.files[0].name;
          setTimeout(() => {
            this.dynaltImageUpload(this.id, name, event.target.files[0]);
          }, 1000);
          break;
      }
    },
    leftNavImageDelete(url) {
      setTimeout(() => {
        this.dragBox.enable = false;
        this.$confirm(
          "确定删除 " + url.split("/")[url.split("/").length - 1] + "？",
          "提示",
          {}
        ).then(({ result }) => {
          this.dragBox.enable = false;
          if (result) {
            this.dynaltImageDelete(this.id, url);
          }
        });
      }, 1);
    },

    /* - - - - - - - */

    dynaltConfig(id, config) {
      dynalt_Config({ id, config })
        .then(res => {
          if (res.data.code == 200) {
            this.$toast.success(res.data.msg);
          } else {
            this.$toast.error("保存失败");
          }
        })
        .catch(this.catchErr);
    },
    dynaltUpdate(data) {
      this.viewLock = false;
      dynalt_Update(data)
        .then(res => {
          if (res.data.code == 200) {
            this.dynaltRetrieve(this.id);
            this.$toast.success(res.data.msg);
          } else {
            this.$toast.error(res.data.msg);
          }
        })
        .catch(this.catchErr);
    },
    dynaltRetrieve(id) {
      dynalt_Retrieve(id)
        .then(res => {
          if (res.data.code == 200) {
            this.dynalt = res.data.return.dynalt2;
            if (this.dynalt.config.canvas == 0) {
              this.dynalt.config.canvas.push({
                name: "画布1（右键删除）",
                background: "#fff",
                element: [],
              });
            }
          } else {
            this.$toast.error("组态不存在");
          }
        })
        .catch(this.catchErr);
    },
    dynaltMaterialPrivate() {
      dynalt_Material_Private()
        .then(res => {
          if (res.data.code == 200) {
            if (res.data.return.list == null) {
              res.data.return.list = [];
            }
            this.LNoption.material = res.data.return.list;
          }
        })
        .catch(this.catchErr);
    },
    dynaltImageUpload(id, name, file) {
      let param = new FormData();
      param.append("id", id);
      param.append("name", name);
      param.append("file", file);
      dynalt_Image_Upload(param)
        .then(res => {
          if (res.data.code == 200) {
            this.$toast.success("上传成功");
          } else {
            this.$toast.error("上传失败");
          }
          this.dynaltImageList(id);
        })
        .catch(this.catchErr);
    },
    dynaltImageList(id) {
      this.viewLock = false;
      dynalt_Image_List(id)
        .then(res => {
          if (res.data.code == 200) {
            if (res.data.return.list == null) {
              res.data.return.list = [];
            }
            this.LNoption.image = res.data.return.list;
            this.viewLock = true;
          }
        })
        .catch(this.catchErr);
    },
    dynaltImageDelete(id, name) {
      dynalt_Image_Delete(id, name)
        .then(res => {
          if (res.data.code == 200) {
            this.$toast.success("删除成功");
          } else {
            this.$toast.error("删除失败");
          }
          this.dynaltImageList(id);
        })
        .catch(this.catchErr);
    },
    tolinkStream(token) {
      tolink_Stream(token)
        .then(res => {
          if (res.data.code == 200) {
            if (res.data.return.stream == null) {
              res.data.return.stream = [];
            }
            this.stream = res.data.return.stream;
          }
        })
        .catch(this.catchErr);
    },
    tolinkLabel(apiKey) {
      tolink_Label(apiKey)
        .then(res => {
          if (res.data.code == 200) {
            if (res.data.return.label.list == null) {
              res.data.return.label.list = [];
            }
            this.$set(this.label, apiKey, res.data.return.label.list);
          }
        })
        .catch(this.catchErr);
    },
    tolinkRealtime(apiKey, list) {
      tolink_Realtime(apiKey, list)
        .then(res => {
          if (res.data.code == 200) {
            if (res.data.return.labels == null) {
              res.data.return.labels = [];
            }
            for (let index in res.data.return.labels) {
              this.realtime[res.data.return.labels[index]] = {
                value: res.data.return.values[index],
                status: res.data.return.status[index],
                time: res.data.return.times[index],
              };
              this.realtime.update =
                this.realtime.update > 19970801 ? 0 : this.realtime.update + 1;
            }
          }
        })
        .catch(this.catchErr);
    },
    tolinkMqttwrite(apiKey, labelID, value, log) {
      tolink_Mqttwrite(apiKey, labelID, value)
        .then(res => {
          if (log) {
            this.control.log.unshift({
              value,
              time: Math.round(new Date().getTime() / 1000),
              msg: res.data.msg,
            });
          } else {
            if (res.data.code == 200) {
              this.$toast.success("下发成功，等待响应");
            } else {
              this.$toast.error(res.data.msg);
            }
          }
        })
        .catch(this.catchErr);
    },

    catchErr(err) {
      console.log(err);
      this.$toast.error("网络请求异常");
    },

    /* - - - - - - - */

    colorHandle(act) {
      switch (act) {
        case "input":
          this.color.pointer[this.color.pkey] =
            this.color.value[this.color.type];
          break;
        case "check":
          this.colorDisable();
          break;
        case "clear":
          this.color.pointer[this.color.pkey] = this.color.cache;
          this.colorDisable();
          break;
      }
    },
    colorEnable(obj, key, top, left) {
      if (top > this.windowHeight / 2) {
        this.color.top = top - 348 - 10;
      } else {
        this.color.top = top + 40;
      }
      this.color.left = left - 110 + 14;
      this.color.pointer = obj;
      this.color.pkey = key;
      this.color.value = obj[key];
      this.color.cache = obj[key];
      this.color.enable = true;
    },
    colorDisable() {
      this.color.top = 0;
      this.color.left = 0;
      this.color.pointer = {};
      this.color.pkey = "";
      this.color.cache = "";
      this.color.enable = false;
    },
    getDatetime(time) {
      var now = time > 0 ? new Date(time * 1000) : new Date();
      var year = now.getFullYear();
      var month = now.getMonth() + 1;
      var day = now.getDate();
      var hh = now.getHours();
      var mm = now.getMinutes();
      var ss = now.getSeconds();
      var clock = year + "-";
      if (month < 10) clock += "0";
      clock += month + "-";
      if (day < 10) clock += "0";
      clock += day + " ";
      if (hh < 10) clock += "0";
      clock += hh + ":";
      if (mm < 10) clock += "0";
      clock += mm + ":";
      if (ss < 10) clock += "0";
      clock += ss;
      return clock;
    },
    getTime(time) {
      var now = time > 0 ? new Date(time * 1000) : new Date();
      var hh = now.getHours();
      var mm = now.getMinutes();
      var ss = now.getSeconds();
      var clock = "";
      if (hh < 10) clock += "0";
      clock += hh + ":";
      if (mm < 10) clock += "0";
      clock += mm + ":";
      if (ss < 10) clock += "0";
      clock += ss;
      return clock;
    },
    dataShow(data, content) {
      if (typeof data !== "object") return "暂无";
      if (data.status <= 0) return "异常";
      switch (content) {
        case "value":
          return data.value;
        case "time":
          return this.getDatetime(data.time);
        default:
          return "";
      }
    },
    switchShow(data) {
      if (typeof data !== "object" || data.status <= 0) return -1;
      if (data.value == 0) return 0;
      else return 1;
    },
  },
  computed: {
    leftNavStyle() {
      return this.funcULCur == -1 ? "transform: translateX(-240px)" : "";
    },
    rightNavStyle() {
      return this.rightNavHidden
        ? "transform: translateX(240px);transition: transform 0.5s;"
        : "";
    },
    pCanvas() {
      return this.dynalt.config.canvas[this.canvasCur];
    },
    pElement() {
      if (this.elementCur < 0) {
        return {};
      }
      return this.pCanvas.element[this.elementCur];
    },
  },
  filters: {
    textareaHandle(val) {
      return val.replace(/\n/g, '"<br>"');
    },
  },
};
</script>

<style lang="less">
#edit {
  height: 100%;
  width: 100%;

  user-select: none;
}

.pc-body {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  background-color: #fff;
}

.pc-head {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background-color: #383e41;
  text-align: center;
  z-index: 19970801;
}

.pc-head-back {
  position: relative;
  float: left;
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  color: #fff;
  font-size: 26px;
  background-color: #2f2f2f;
}
.pc-head-back .mu-icon {
  cursor: pointer;
  margin: 16px;
}

.pc-head-right {
  position: relative;
  float: right;
  margin-right: 20px;
}

.pc-head-ico {
  position: relative;
  float: right;
  height: 60px;
  line-height: 60px;
  padding: 0 7px;
  color: #e0e0e0;
  font-size: 14px;
  user-select: none;
  cursor: pointer;
}

.pc-head-ico:hover {
  color: #fff;
}
.pc-head-ico:active {
  text-shadow: 2px 2px 4px rgb(0, 0, 0, 0.3);
}
.pc-info {
  display: inline-block;
  height: 60px;
  line-height: 60px;
  color: #fff;
  font-size: 16px;
}

.pc-con {
  position: absolute;
  top: 60px;
  left: 60px;
  right: 0;
  bottom: 0;
}

.pc-left {
  position: fixed;
  z-index: 19970801;
  top: 60px;
  left: 0;
  bottom: 0;
  width: 60px;
  background-color: #4a5053;
}
.pc-left ul {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 180px;
  margin: 0;
  padding: 0;
}

.pc-leftUL {
  width: 100%;
  height: calc(100% - 180px);

  padding: 20px 0;

  overflow-x: hidden;
  overflow-y: scroll;
}

.pc-leftUL::-webkit-scrollbar {
  display: none;
}

.pc-leftUL-item {
  position: relative;
  display: block;
  width: 100%;
  height: 80px;
  line-height: 24px;
  float: left;
  color: #999ea8;
  text-align: center;
  font-size: 14px;

  padding: 15px 0;
  user-select: none;
  cursor: pointer;
}

.pc-leftUL-item > div {
  height: 26px;
}
.pc-leftUL-item p {
  height: 24px;
  margin: 0;
}
.pc-leftUL-item:hover {
  color: #fff;
}

.pc-leftRM {
  width: 100%;
  height: 180px;
}

.pc-right {
  position: fixed;
  top: 60px;
  bottom: 0;
  right: 0;
  width: 240px;
  background-color: #41474a;
  z-index: 19970801;
  transform: translateX(0);
  transition: transform 0.6s;
}
/* - - - - - - - - */

.leftNav {
  position: fixed;
  top: 60px;
  left: 60px;
  width: 240px;
  bottom: 0;
  background-color: #fff;
  z-index: 1001;
  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.15);
  overflow: hidden;

  transform: translateX(0);
  transition: transform 0.6s;
}

.leftNav .funcItem {
  position: absolute;

  width: calc(100% - 20px);
  height: calc(100% - 20px);

  margin: 10px;

  overflow-x: hidden;
  overflow-y: scroll;
}
.funcItem::-webkit-scrollbar {
  display: none;
}

.funcItem-title {
  display: flex;
  width: 100%;
  height: 40px;
}
.funcItem-title div {
  flex: 1;
  height: 20px;
  border-bottom: 1px solid #333;
}
.funcItem-title span {
  display: inline-block;
  height: 20px;
  margin: 10px;
  color: #333;
  font-size: 12px;
}

.funcItem-buttom {
  width: 100%;
  height: 30px;
  margin: 5px 0;
}
.funcItem-buttom label {
  display: inline-block;
  height: 30px;

  background: #2196f3;
  border-radius: 36px;
  padding: 0 16px;
  box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.2);

  font-size: 14px;
  line-height: 30px;
  text-align: center;
  color: #fff;
}
.funcItem-buttom label:hover {
  background: #3aa6ff;
}
.funcItem-buttom label:active {
  background: #3aa6ff;
  box-shadow: 3px 3px 13px rgba(0, 0, 0, 0.4);
}

.leftNav-base {
  float: left;
  width: 110px;
  height: 80px;

  margin: 10px 0;

  border: 1px solid #fff;
  cursor: move;
}
.leftNav-base:hover {
  border: 1px solid #00c4cd;
}
.leftNav-base div {
  height: 50px;
  padding: 5px 0;
  text-align: center;
}
.leftNav-base span {
  display: inline-block;
  width: 100%;
  height: 20px;
  line-height: 20px;
  color: #666;
  font-size: 14px;

  text-align: center;
}

.leftNav-module {
  position: relative;
  float: left;
  height: 105px;
  width: 105px;

  margin-right: 10px;
  margin-bottom: 10px;
  border-radius: 6px;

  background: #666;
  text-align: center;

  cursor: move;
}
.leftNav-module div {
  position: absolute;
  bottom: 10px;
  width: 100%;
  height: 20px;

  color: #fff;
  text-align: center;
}
.leftNav-module img {
  height: 60px;
  margin: 10px 0;
}

.leftNav-material {
  float: left;
  width: 105px;
  height: 118px;
  line-height: 118px;

  margin-right: 10px;
  margin-bottom: 10px;
  text-align: center;
  border: 1px solid transparent;

  cursor: move;
}
.leftNav-material:hover {
  border: 1px solid #00c4cd;
}
.leftNav-material img {
  display: inline-block;
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  border: none;
  vertical-align: middle;
}

.leftNav-active {
  position: relative;
  float: left;
  height: 105px;
  width: 105px;

  margin-right: 10px;
  margin-bottom: 10px;
  border-radius: 6px;

  background: #666;
  text-align: center;

  cursor: move;
}
.leftNav-active div {
  position: absolute;
  bottom: 10px;
  width: 100%;
  height: 20px;

  color: #fff;
  text-align: center;
}
.leftNav-active img {
  height: 60px;
  margin: 10px 0;
}

.leftNav-image {
  position: relative;
  float: left;
  width: 105px;
  height: 138px;

  margin-right: 10px;
  margin-bottom: 10px;
  text-align: center;
  border: 1px solid transparent;
  cursor: move;

  overflow: hidden;
}
.leftNav-image:hover {
  border: 1px solid #00c4cd;
}
.leftNav-image:hover button {
  display: inline-block;
}
.leftNav-image div {
  width: 105px;
  height: 118px;
  line-height: 118px;
  line-height: 118px;
}
.leftNav-image div img {
  display: inline-block;
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  border: none;
  vertical-align: middle;
}
.leftNav-image span {
  display: inline-block;
  height: 20px;
  width: 100%;
  color: #333;
  font-size: 12px;
  overflow: hidden;
  padding: 0 5px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.leftNav-image button {
  position: absolute;
  display: none;
  top: 0;
  right: 0;

  height: 20px;
  width: 20px;

  margin: none;
  border: none;
  outline: none;
  padding: 0;

  background: rgba(173, 67, 67, 0.5);
  cursor: pointer;
}
.leftNav-image button:hover {
  background: rgba(173, 67, 67, 0.8);
}
.leftNav-image button .mu-icon {
  margin: 2px;
}
/* - - - - - - - - */

.rightNav {
  position: absolute;
  top: 40px;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
}

.rightNav-btn {
  position: relative;
  left: 0;
  width: 239px;
  height: 30px;
  background-color: #41474a;
  cursor: pointer;

  transform: translateX(0);
  transition: transform 0.5s;
}
.rightNav-btn:hover {
  background-color: #5c6164;
}
.rightNav-btn:active {
  background-color: #4b5153;
}
.rightNav-btn .mu-icon {
  margin: 3px 6px;
}

.rightNav-head {
  position: relative;
  width: 100%;
  height: 40px;
  overflow: hidden;
}

.rightNavHeadA {
  position: relative;
  float: left;
  width: 50%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 14px;
  color: #999ea8;
  border-bottom: 1px solid #676c75;
  cursor: pointer;
  user-select: none;
}

.rightNavHeadB {
  color: #fff;
  border-bottom: 1px solid #4c84ff;
}

.rightNav-body {
  width: 100%;
  height: calc(100% - 40px - 1px);
  font-size: 12px;
}

.rightNav-separate {
  height: 15px;
  width: 100%;
  border-bottom: 1px solid #4a5053;
  margin-bottom: 15px;
}

.rightNav-item {
  display: inline-block;
  position: relative;
  width: 100%;
  padding: 10px 15px 15px 15px;
}
.rightNav-text {
  display: block;
  position: relative;
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  color: #f5f6fa;
  user-select: none;
}

.rightNav-item-list {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.rightNav-item-list .mu-icon {
  margin-top: 4px;
}
.rightNav-item-list span {
  display: inline-block;
  width: 30px;
  height: 30px;
  line-height: 30px;
  color: #fff;
}

.rightNav-input {
  display: inline-block;
  height: 30px;
  width: 100%;
  background: #fff;
  border: 1px solid #000;
  margin-right: 10px;
}
.rightNav-input input {
  width: 100%;
  height: 100%;

  padding: 0 5px;
  border: none;
  outline: none;
  margin: none;
  background: none;
}

.rightNav-button {
  display: inline-block;
  position: relative;
  top: -2px;
  height: 30px;
}
.rightNav-button .mu-raised-button {
  min-width: 10px;
}
.rightNav-button .mu-button-small {
  height: 28px;
}

.rightNav-select {
  height: 28px;
  width: 100%;
  background: #fff;
  border: 1px solid #fff;
}
.rightNav-select select {
  width: 100%;
  height: 100%;

  padding: 0 5px;
  border: none;
  outline: none;
  margin: none;
  background: none;

  // text-align: center;
  // text-align-last: center;
}

.rightNav-item .rightNav-checkbox {
  cursor: pointer;
  border: 1px solid #4c84ff;
}

.rightNav-box {
  height: 30px;
  width: 30px;
  text-align: center;
  margin-right: 20px;
  border: 1px solid #41474a;
  cursor: pointer;
}

.rightNav-colorbox {
  width: 30px;
  height: 30px;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==);
}

.rightNav-view {
  position: absolute;
  width: 100%;
  height: calc(100% - 40px);
  overflow-y: scroll;
}
.rightNav-view::-webkit-scrollbar {
  display: none;
}

.rightNav-details {
  display: flex;
  width: 100%;
  height: 20px;
}
.rightNav-details > span {
  font-size: 14px;
  color: #f5f6fa;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
  padding: 0 10px;
}

.rightNav-details > div {
  flex: 1;
  height: 50%;
  border-bottom: 1px solid #4c84ff;
}

.rightNav-textarea {
  height: 60px;
  width: 210px;
}
.rightNav-textarea textarea {
  position: relative;
  width: 100%;
  height: 100%;

  padding: 0 5px;
  border: 1px solid #000;
  border-right: none;
  overflow-x: hidden;
  outline: none;
  margin: none;

  line-height: 20px;
  resize: none;
}
.rightNav-textarea textarea::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
.rightNav-textarea textarea::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #aaa;
}
.rightNav-textarea textarea::-webkit-scrollbar-track {
  border-radius: 0;
  background: #000;
}

.rightNav-manybox {
  display: flex;
  height: 25px;
  width: 100%;
}
.rightNav-manybox select {
  flex: 1;
  padding: 5px 0;
  margin: none;
  outline: none;

  overflow: visible;
}

.rightNav-manybox button {
  display: inline-block;
  width: 100%;
  height: 100%;

  line-height: 1;
  flex: 1;
  margin: none;
  outline: none;

  font-size: 14px;
}

/* - - - - - - - - */

.pc-edit {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;

  overflow: scroll;

  background: #f5f6fa;
}

.editNav-side {
  position: absolute;
  z-index: 1000;

  background: green;

  text-align: center;

  white-space: nowrap;
}
.editNav-side::-webkit-scrollbar {
  width: 2px;
  height: 2px;
}
.editNav-side::-webkit-scrollbar-thumb {
  background: #666;
}
.editNav-side::-webkit-scrollbar-track {
  background: #fff;
}

.editNav-item {
  height: 40px;

  line-height: 40px;
  padding: 0 10px;
  user-select: none;
  cursor: pointer;
}

.editCenter {
  position: relative;
  display: inline-block;
}

.editCenter-guide {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
.guide-enable {
  background-image: url(../assets/guide.png);
}

.editCenter-expansion {
  position: absolute;
  bottom: -60px;
  right: -300px;
  width: 1px;
  height: 1px;
}

.editCenter-resizable-rotate {
  position: absolute;
  left: 50%;
  top: -45px;
  margin-left: -12px;
  width: 24px;
  height: 24px;
  background-image: url(../assets/edit/center_rotate.svg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  z-index: 2000;
}
.editCenter-resizable {
  position: absolute;
  font-size: 0.1px;
  display: block;
  -ms-touch-action: none;
  touch-action: none;

  z-index: 90;
}
.resizable-n {
  border-top: 1px dashed #383e41;
  width: auto;
  height: 10px;
  left: -9px;
  top: -10px;
  right: -9px;
  cursor: n-resize;
}
.resizable-n:before {
  content: "";
  left: 50%;
  top: -5px;
  margin-left: -5px;
  position: absolute;
  width: 10px;
  height: 10px;
  border: solid 1px #383e41;
  background-color: #fff;
}
.resizable-e {
  border-right: 1px dashed #383e41;
  width: 10px;
  bottom: -9px;
  right: -10px;
  top: -9px;
  height: auto;
  cursor: e-resize;
}
.resizable-e:before {
  content: "";
  width: 10px;
  height: 10px;
  border: solid 1px #383e41;
  top: 50%;
  right: -5px;
  margin-top: -5px;
  position: absolute;
  background-color: #fff;
}
.resizable-s {
  border-bottom: 1px dashed #383e41;
  width: auto;
  height: 10px;
  left: -9px;
  bottom: -10px;
  right: -9px;
  cursor: s-resize;
}
.resizable-s:before {
  content: "";
  width: 10px;
  height: 10px;
  border: solid 1px #383e41;
  left: 50%;
  bottom: -5px;
  margin-left: -5px;
  position: absolute;
  background-color: #fff;
}
.resizable-w {
  border-left: 1px dashed #383e41;
  width: 10px;
  height: auto;
  left: -10px;
  top: -9px;
  bottom: -9px;
  cursor: w-resize;
}
.resizable-w:before {
  content: "";
  width: 10px;
  height: 10px;
  border: solid 1px #383e41;
  left: -5px;
  top: 50%;
  margin-top: -5px;
  position: absolute;
  background-color: #fff;
}
.resizable-ne {
  width: 12px;
  height: 12px;
  background-color: #ffffff;
  border: solid 1px #383e41;
  border-radius: 50%;
  right: -15px;
  top: -15px;
  cursor: ne-resize;
}
.resizable-se {
  width: 12px;
  height: 12px;
  background-color: #ffffff;
  border: solid 1px #383e41;
  border-radius: 50%;
  right: -15px;
  bottom: -15px;
  cursor: se-resize;
}
.resizable-sw {
  width: 12px;
  height: 12px;
  background-color: #ffffff;
  border: solid 1px #383e41;
  border-radius: 50%;
  left: -15px;
  bottom: -15px;
  cursor: sw-resize;
}
.resizable-nw {
  width: 12px;
  height: 12px;
  background-color: #ffffff;
  border: solid 1px #383e41;
  border-radius: 50%;
  left: -15px;
  top: -15px;
  cursor: nw-resize;
}

.editCenter-item {
  position: absolute;
  display: inline-block;
}

.editCenter-item-body {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.editCenter-base {
  width: 100%;
  height: 100%;

  white-space: pre;
  overflow: hidden;
}
.editCenter-base,
.editCenter-base * {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
}
.editCenter-base-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  overflow: hidden;
}

.editCenter-item-lock {
  position: absolute;
  z-index: -1;
  top: -5px;
  left: -5px;
  width: calc(100% + 10px);
  height: calc(100% + 10px);
  border: 1px dashed #4c84ff;
}
.editCenter-item-lock .mu-icon {
  position: absolute;
  top: -5px;
  right: -5px;
  border: 1px solid #666;
  border-radius: 6px;
  background: #fff;
}

/* - - - - - - - - */

.pc-color {
  position: absolute;
  z-index: 19970802;

  background: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.1);

  backdrop-filter: blur(8px);
}

.pc-drag {
  display: inline-block;
  position: absolute;
  z-index: 19970803;
  left: 50%;
  top: 50%;
}

.pc-menu {
  position: fixed;
  width: 150px;
  z-index: 19970804;
  overflow: hidden;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.1);
  padding: 5px 0;
}
.pc-menu-item {
  position: relative;
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  padding: 0 10px;
  color: #4a5053;
  cursor: pointer;
}
.pc-menu-item:hover {
  background: rgb(76, 132, 255);
  color: #fff;
}
.pc-menu-item span {
  font-size: 12px;
  color: #bfc5d1;
  float: right;
}

.pc-control {
  position: fixed;
  top: calc(50% - 190px - 60px);
  left: calc(50% - 200px);
  width: 400px;
  height: 380px;
  z-index: 19970804;

  background: #fff;
  box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.1);
}
.pc-control-head {
  width: 100%;
  height: 40px;
  background: #f5f5f5;
  color: #333;
  padding: 0 15px;
  border-bottom: 1px solid #ccc;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.pc-control-head span {
  display: inline-block;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  font-weight: 500;
  margin-right: 10px;
}
.pc-control-body {
  padding: 15px;
}
.pc-control-body .pc-control-view {
  width: 100%;
  height: 170px;
  border: 1px solid #ccc;

  overflow-y: scroll;
  overflow-x: hidden;

  margin-bottom: 20px;
  padding: 5px 0;
}
.pc-control-body .pc-control-view-item {
  height: 20px;
  line-height: 20px;
  padding: 0 10px;
  font-size: 12px;
}
.pc-control-body textarea {
  display: inline-block;
  width: 100%;
  height: 72px;

  border: 1px solid #ccc;
  padding: 6px 12px;
  outline: none;
  margin: none;
  overflow-x: hidden;

  font-size: 14px;
  color: #555;
}
.pc-control-body textarea::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
.pc-control-body textarea::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #000;
}
.pc-control-body textarea::-webkit-scrollbar-track {
  border-radius: 0;
  background: #aaa;
}
.pc-control-btn {
  margin-top: 10px;
  height: 30px;
}
.pc-control-btn .mu-button {
  float: right;
  margin-left: 10px;
}

.slide-left-enter-active,
.slide-left-leave-active {
  transition: all 0.35s ease-out;
}
.slide-left-enter,
.slide-left-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}

.slide-right-enter-active,
.slide-right-leave-active {
  transition: all 0.35s ease-out;
}
.slide-right-enter,
.slide-right-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.6s ease-out;
}
.fade-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
.fade-enter {
  transform: translateX(-100%);
  opacity: 0;
}
</style>